<template>
  <div class="container">
    <div v-if="!$deviceState.isMobile">
      <div class="header">
        <p class="title">昌恩暖通智控节能项目投资回报预算详情</p>
        <div class="df-normal backContainer">
          <!-- <img
          class="backImg"
          src="@/assets/imgs/maintenanceCenter/arrows.png"
          alt=""
        />
        <span class="backTxt">返回</span> -->
          <div v-if="permissionAccess">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
              >
              <el-breadcrumb-item>系统管理</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/userManagement' }">
                用户管理
              </el-breadcrumb-item>
              <el-breadcrumb-item
                :to="{
                  path: `/userManagementDetails?id=${$route.query.id}&userName=${$route.query.userName}`,
                }"
              >
                用户管理详情{{ $route.query.userName }}
              </el-breadcrumb-item>
              <el-breadcrumb-item> 预算数据详情 </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div v-else>
            <el-breadcrumb>
              <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
              >
              <el-breadcrumb-item to="">{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>

      <!-- 1 -->

      <div
        class="itemContainer"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="t-a-c df-normal">
          <h4 style="width: 150px; font-weight: 600">项目名称:</h4>
          <el-input placeholder="请输入项目名称" v-model="name"></el-input>
        </div>

        <h3>基本项目数据</h3>
        <el-row :gutter="12" class="row-box">
          <el-col :sm="12" :md="8" :lg="7" :xl="4" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <el-tooltip
                  effect="dark"
                  content="项目暖通系统年用电量(kwh)"
                  placement="top-start"
                >
                  <p class="t-a-l els">
                    项目暖通系统年用电量(kwh) <i class="red">*</i>
                  </p>
                </el-tooltip>
                <el-button
                  v-if="showBtn1"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseItemAnnualElectricityConsumption"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm"
                  ></el-button>
                </div>
              </div>
              <div class="t-a-l df-normal">
                <el-col>
                  <el-input
                    v-model="HVAC_EnergyConsumption_Annual"
                    ref="btnAnnualElectricityConsumption"
                    :disabled="showBtn1"
                  >
                    <template slot="append">kwh</template>
                  </el-input>
                </el-col>
              </div>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="6" :lg="5" :xl="3" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">年均节能率<i class="red">*</i></p>
                <el-button
                  v-if="showBtn2"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseHVAC_AveragePSR_Annual"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel2"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm2"
                  ></el-button>
                </div>
              </div>
              <div class="t-a-l df-normal">
                <el-col :span="24">
                  <el-input
                    v-model="HVAC_AveragePSR_Annual"
                    ref="btnHVAC_AveragePSR_Annual"
                    :disabled="showBtn2"
                  >
                    <!-- class="setRight" -->
                    <template slot="append"> % </template>
                  </el-input>
                </el-col>
                <!-- <el-col :span="12">%</el-col> -->
              </div>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="10" :lg="8" :xl="5" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">年均节电量（度）+ 年度减碳量</p>
              </div>
              <el-col :span="12">
                <el-input
                  class="noBorder pd0"
                  :disabled="true"
                  v-model="HVAC_PowerSavings_Annual"
                >
                  <template slot="append">kwh</template>
                </el-input>
              </el-col>

              <el-col :span="12">
                <el-input
                  class="noBorder pd0"
                  :disabled="true"
                  v-model="HVAC_CarbonReduction_Annual"
                >
                  <template slot="append">kg</template>
                </el-input>
              </el-col>
            </el-card>
          </el-col>
          <el-col :sm="12" :md="6" :lg="4" :xl="4" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">月均节电量（度）</p>
              </div>
              <el-input
                class="noBorder"
                :disabled="true"
                v-model="HVAC_PowerSavings_Monthly"
              >
                <template slot="append">kwh</template>
              </el-input>
            </el-card>
          </el-col>

          <el-col :sm="8" :md="6" :lg="4" :xl="4" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">电费单价 <i class="red">*</i></p>
                <el-button
                  v-if="showBtn3"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="basePower_UnitPrice"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel3"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm3"
                  ></el-button>
                </div>
              </div>
              <div class="t-a-l">
                <el-input
                  v-model="Power_UnitPrice"
                  ref="btnPower_UnitPrice"
                  :disabled="showBtn3"
                  ><template slot="append">￥</template></el-input
                >
              </div>
            </el-card>
          </el-col>
          <el-col :sm="8" :md="6" :lg="4" :xl="4" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">项目年均总节电费</p>
              </div>
              <el-input
                class="noBorder"
                :disabled="true"
                v-model="HVAC_Savings_Total"
              >
                <template slot="append">￥</template>
              </el-input>
            </el-card>
          </el-col>
          <!-- </el-row> -->

          <!-- 第二列 -->
          <!-- <el-row :gutter="12" class="row-box mg-t-10"> -->
          <el-col :sm="8" :md="6" :lg="4" :xl="3" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">建设毛成本 <i class="red">*</i></p>
                <el-button
                  v-if="showBtn4"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseCost_Construction"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel4"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm4"
                  ></el-button>
                </div>
              </div>
              <div class="t-a-l">
                <el-input
                  v-model="Cost_Construction"
                  ref="btnCost_Construction"
                  :disabled="showBtn4"
                  ><template slot="append">￥</template></el-input
                >
              </div>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="10" :lg="8" :xl="5" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">项目基础运维成本<i class="red">*</i></p>
                <el-button
                  v-if="showBtn5"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseCost_OM_Anuual"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel5"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm5"
                  ></el-button>
                </div>
              </div>
              <el-col :span="12">
                <div class="t-a-l df-normal itemContent">
                  <p class="year">年度：</p>
                  <el-input
                    v-model="Cost_OM_Anuual"
                    ref="btnCost_OM_Anuual"
                    :disabled="showBtn5"
                    class="setLeft"
                  >
                    <template slot="append">￥</template>
                  </el-input>

                  <!-- <p class="year">年度：</p>
                <p contenteditable="true" class="formatInput">
                  {{ Cost_OM_Anuual }}
                </p> -->
                </div>
              </el-col>
              <el-col :span="12">
                <div class="t-a-l df-normal itemContent">
                  <!-- <p class="itemContent">6年： {{ Cost_OM_Anuual_Total }}</p> -->
                  <p class="year">{{ form_share_period }}年：</p>
                  <el-input
                    v-model="Cost_OM_Anuual_Total"
                    :disabled="true"
                    class="setLeft"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </div>
              </el-col>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="7" :lg="4" :xl="3" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">项目贷款情况<i class="red">*</i></p>
              </div>
              <el-col :span="14">
                <div class="t-a-l df-normal itemContent">
                  <el-radio-group
                    :disabled="disabledAllBtn"
                    v-model="Loan_Status"
                    @change="select_Loan_Status"
                  >
                    <el-radio :label="0">全额贷款</el-radio>
                    <el-radio :label="1">无贷款</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="7" :lg="4" :xl="3" style="margin: 6px 0">
            <el-card class="box-card" :class="showGrey == 1 ? 'greyOut' : ''">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">项目贷款额 <i class="red">*</i></p>
                <div v-if="disabledAllBtn">
                  <div v-if="disabledAllBtn">
                    <el-button
                      :disabled="disabledAllBtn"
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      @click="baseLoan_Amount"
                    ></el-button>
                  </div>
                  <div v-else class="df-normal">
                    <el-button
                      type="info"
                      icon="el-icon-close"
                      circle
                      size="mini"
                      @click="cancel7"
                    ></el-button>
                    <el-button
                      type="success"
                      icon="el-icon-check"
                      circle
                      size="mini"
                      @click="confirm7"
                    ></el-button>
                  </div>
                </div>
                <div v-else>
                  <div v-if="showBtn7">
                    <el-button
                      :disabled="showGrey == 1"
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      @click="baseLoan_Amount"
                    ></el-button>
                  </div>
                  <div v-else class="df-normal">
                    <el-button
                      type="info"
                      icon="el-icon-close"
                      circle
                      size="mini"
                      @click="cancel7"
                    ></el-button>
                    <el-button
                      type="success"
                      icon="el-icon-check"
                      circle
                      size="mini"
                      @click="confirm7"
                    ></el-button>
                  </div>
                </div>
              </div>
              <div class="t-a-l">
                <el-input
                  v-model="Loan_Amount"
                  ref="btnLoan_Amount"
                  :disabled="showBtn7"
                  ><template slot="append">￥</template></el-input
                >
              </div>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="10" :lg="8" :xl="5" style="margin: 6px 0">
            <el-card class="box-card" :class="showGrey == 1 ? 'greyOut' : ''">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">贷款年利率 + 年限 <i class="red">*</i></p>
                <div v-if="disabledAllBtn">
                  <el-button
                    :disabled="disabledAllBtn"
                    v-if="showBtn8"
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="baseLoan_InterestRate_Annual"
                  ></el-button>
                </div>
                <div v-else>
                  <el-button
                    :disabled="showGrey == 1"
                    v-if="showBtn8"
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="baseLoan_InterestRate_Annual"
                  ></el-button>
                  <div v-else class="df-normal">
                    <el-button
                      type="info"
                      icon="el-icon-close"
                      circle
                      size="mini"
                      @click="cancel8"
                    ></el-button>
                    <el-button
                      type="success"
                      icon="el-icon-check"
                      circle
                      size="mini"
                      @click="confirm8"
                    ></el-button>
                  </div>
                </div>
              </div>

              <div class="df-ac-jsb clearfix">
                <el-col :span="12">
                  <div class="t-a-l df-normal">
                    <p class="" style="width: 90px">
                      年利率<i class="red">*</i>
                    </p>
                    <el-input
                      v-model="filterLoan_InterestRate_Annual"
                      ref="btnLoan_InterestRate_Annual"
                      :disabled="showBtn8"
                      class="setCenter"
                      ><template slot="append">%</template></el-input
                    >
                  </div>
                </el-col>

                <el-col :span="12">
                  <div class="t-a-l df-normal">
                    <p class="" style="width: 50px">年限<i class="red">*</i></p>
                    <el-input
                      class="setCenter"
                      v-model="Loan_Term"
                      :disabled="showBtn8"
                      ><template slot="append">年</template></el-input
                    >
                  </div>
                </el-col>
              </div>
            </el-card>
          </el-col>
          <!--  -->
          <el-col :sm="12" :md="8" :lg="8" :xl="3" style="margin: 6px 0">
            <el-card class="box-card" :class="showGrey == 1 ? 'greyOut' : ''">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l mg-t-6 els">先息后本；年利息额</p>
              </div>
              <div class="t-a-l">
                <el-input v-model="Loan_Intrest_Annual" :disabled="setBtnShow">
                  <template slot="append">￥</template>
                </el-input>
              </div>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="6" :lg="4" :xl="2" style="margin: 6px 0">
            <el-card class="box-card" :class="showGrey == 1 ? 'greyOut' : ''">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l mg-t-6 els">贷款利息总额</p>
              </div>
              <div class="t-a-l">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="Loan_Interest_Total"
                  placement="top-start"
                >
                  <el-input
                    v-model="Loan_Interest_Total"
                    :disabled="setBtnShow"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-tooltip>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 2 -->
      <!-- <h3>能源管理合同模式 (EMC) 项目回报测算</h3> -->
      <div
        class="itemContainer2"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <h3>能源管理合同模式 (EMC) 项目回报测算</h3>
        <el-row :gutter="12" class="row-box">
          <el-col :sm="12" :md="9" :lg="9" :xl="5">
            <el-card class="box-card custom_card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-top-f8">
                  昌恩项目分成模式<i class="red">*</i>

                  <!-- 年限选择 -->
                  <el-select
                    v-model="form_share_period"
                    placeholder="年限"
                    style="width: 45%; margin-left: 10px"
                    @change="changePeriod"
                  >
                    <el-option label="年限：5年" value="5"></el-option>
                    <el-option label="年限：6年" value="6"></el-option>
                    <el-option label="年限：7年" value="7"></el-option>
                    <el-option label="年限：8年" value="8"></el-option>
                  </el-select>
                  <!--  -->
                </p>

                <div class="mg-top-f8">
                  <el-button
                    v-if="showBtn_HVACEMC_BSM_CEBSP"
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="modeHVACEMC_BSM_CEBSP_FP"
                  ></el-button>
                  <div v-else class="df-normal">
                    <el-button
                      type="info"
                      icon="el-icon-close"
                      circle
                      size="mini"
                      @click="cancel_HVACEMC_BSM_CEBSP_FP"
                    ></el-button>
                    <el-button
                      type="success"
                      icon="el-icon-check"
                      circle
                      size="mini"
                      @click="confirm_HVACEMC_BSM_CEBSP_FP"
                    ></el-button>
                  </div>
                </div>
              </div>

              <!-- 占位.. -->
              <div class="t-a-l">
                <div class="df-ac-jsb mg-b-10">
                  <el-col :span="4" class="">
                    <p class="font14"></p>
                  </el-col>
                  <el-col :span="7">
                    <p class="font14 pd-l-10"></p>
                  </el-col>
                  <el-col :span="7">
                    <p class="font14 pd-l-0"></p>
                  </el-col>
                  <el-col :span="6">
                    <p class="font14 pd-l-0">&nbsp;</p>
                  </el-col>
                  <el-col :span="6">
                    <p class="font14 pd-l-0"></p>
                  </el-col>
                </div>
              </div>

              <!-- 年限列表 -->
              <div class="t-a-l">
                <!-- <el-radio
                v-model="HVACEMC_BSM_CEBSP"
                :label="0"
                @change="select_HVACEMC_BSM_CEBSP"
                :disabled="disabledAllBtn"
                style="margin: -10px 0"
                >固定比例</el-radio
              > -->
                <div class="df-ac-jsb hvacemc_bsm_cebsp setMargin">
                  <el-col :span="6" class="">
                    <p class="font14 els">第一年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y1_Rate"
                      ref="btnHVACEMC_BSM_CEBSP1"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y1_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp setMargin">
                  <el-col :span="6" class="">
                    <p class="font14 els">第二年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y2_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y2_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp setMargin">
                  <el-col :span="6" class="">
                    <p class="font14 els">第三年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y3_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y3_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp setMargin">
                  <el-col :span="6" class="">
                    <p class="font14 els">第四年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y4_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y4_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp setMargin">
                  <el-col :span="6" class="">
                    <p class="font14 els">第五年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y5_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y5_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div
                  class="df-ac-jsb hvacemc_bsm_cebsp setMargin"
                  v-if="showPeriod >= 6"
                >
                  <el-col :span="6" class="">
                    <p class="font14 els">第六年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y6_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y6_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div
                  class="df-ac-jsb hvacemc_bsm_cebsp setMargin"
                  v-if="showPeriod >= 7"
                >
                  <el-col :span="6" class="">
                    <p class="font14 els">第七年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y7_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y7_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div
                  class="df-ac-jsb hvacemc_bsm_cebsp setMargin"
                  v-if="showPeriod >= 8"
                >
                  <el-col :span="6" class="">
                    <p class="font14 els">第八年<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      :disabled="showBtn_HVACEMC_BSM_CEBSP"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="HVACEMC_BSM_CE_Y8_Rate"
                      ref="btnHVACEMC_BSM_CEBSP"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACEMC_BSM_CE_Y8_Amount">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>
              </div>
            </el-card>
          </el-col>

          <!-- 项目提成比例（昌恩毛利润） -->
          <el-col :sm="12" :md="6" :lg="6" :xl="3">
            <el-card class="box-card card_height commission-rate-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">项目提成比例</p>
                <el-button
                  v-if="showBtn_CommissionRate"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseItemHVACEMC_CommissionRate"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel_HVACEMC_CommissionRate"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm_HVACEMC_CommissionRate"
                  ></el-button>
                </div>
              </div>

              <div class="t-a-l commission-rate">
                <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
                  <el-col :span="11" class="minWidth">
                    <p class="font14 els">商务包：</p>
                  </el-col>
                  <el-col :span="13">
                    <el-input
                      ref="btnHVACEMC_CommissionRate_Agents"
                      :disabled="showBtn_CommissionRate"
                      v-model="HVACEMC_CommissionRate_Agents"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
                  <el-col :span="11" class="minWidth">
                    <p class="font14">销售包：</p>
                  </el-col>
                  <el-col :span="13">
                    <el-input readonly v-model="HVACEMC_CommissionRate_Sales">
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </div>
                <!-- 
              <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
                <el-col :span="11" class="minWidth">
                  <p class="font14">支持包：</p>
                </el-col>
                <el-col :span="13">
                  <el-input readonly v-model="HVACEMC_CommissionRate_Supports">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
                <el-col :span="11" class="minWidth">
                  <p class="font14">总提成：</p>
                </el-col>
                <el-col :span="13">
                  <el-input readonly v-model="HVACEMC_CommissionRate_Total">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </div> -->
              </div>
            </el-card>
          </el-col>

          <!-- 项目预测提成金额 -->
          <el-col :sm="12" :md="9" :lg="9" :xl="4">
            <el-card class="box-card custom_card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">项目预测提成金额</p>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb mg-b-10">
                  <el-col :span="4" class="">
                    <p class="font14"></p>
                  </el-col>
                  <el-col :span="7">
                    <p class="font14 pd-l-10">商务包</p>
                  </el-col>
                  <el-col :span="7">
                    <p class="font14 pd-l-0">销售包</p>
                  </el-col>
                  <!-- <el-col :span="6">
                  <p class="font14 pd-l-0">支持包</p>
                </el-col>
                <el-col :span="6">
                  <p class="font14 pd-l-0">总金额</p>
                </el-col> -->
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb setMargin">
                  <el-col :span="6" class="">
                    <p class="font14">第一年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y1_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y1_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!-- <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y1_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->

                  <!-- <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y1_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin">
                  <el-col :span="6" class="">
                    <p class="font14">第二年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y2_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y2_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!--<el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y2_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y2_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin">
                  <el-col :span="6" class="">
                    <p class="font14">第三年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y3_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y3_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!--<el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y3_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y3_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin">
                  <el-col :span="6" class="">
                    <p class="font14">第四年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y4_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y4_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!--<el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y4_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y4_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin">
                  <el-col :span="6" class="">
                    <p class="font14">第五年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y5_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y5_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!-- <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y5_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y5_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin" v-if="showPeriod >= 6">
                  <el-col :span="6" class="">
                    <p class="font14">第六年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y6_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y6_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!-- <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y6_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y6_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin" v-if="showPeriod >= 7">
                  <el-col :span="6" class="">
                    <p class="font14">第七年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y7_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y7_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!--<el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y7_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y7_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>

                <div class="df-ac-jsb setMargin" v-if="showPeriod >= 8">
                  <el-col :span="6" class="">
                    <p class="font14">第八年</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Agents_Y8_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      class="pd0"
                      readonly
                      v-model="HVACEMC_Commission_Sales_Y8_Amount"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-col>
                  <!--<el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Supports_Y8_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>

                <el-col :span="14">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACEMC_Commission__Total_Y8_Amount"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col> -->
                </div>
              </div>
            </el-card>
          </el-col>

          <!-- 预测效益系数 -->
          <el-col :sm="12" :md="8" :lg="8" :xl="4">
            <el-card class="box-card xyxs-card custom_card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">预测效益系数</p>
              </div>

              <!-- 占位.. -->
              <div class="t-a-l">
                <div class="df-ac-jsb mg-b-10">
                  <el-col :span="4" class="">
                    <p class="font14"></p>
                  </el-col>
                  <el-col :span="7">
                    <p class="font14 pd-l-10"></p>
                  </el-col>
                  <el-col :span="7">
                    <p class="font14 pd-l-0"></p>
                  </el-col>
                  <el-col :span="6">
                    <p class="font14 pd-l-0">&nbsp;</p>
                  </el-col>
                  <el-col :span="6">
                    <p class="font14 pd-l-0"></p>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l first-item">
                <div class="df-ac-jsb xyxs setMargin">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第一年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y1_Amount > 60 &&
                        Coeffcient_Efficiency_Y1_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y1_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y1_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb xyxs setMargin">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第二年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y2_Amount > 60 &&
                        Coeffcient_Efficiency_Y2_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y2_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y2_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb xyxs setMargin">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第三年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y3_Amount > 60 &&
                        Coeffcient_Efficiency_Y3_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y3_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y3_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb xyxs setMargin">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第四年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y4_Amount > 60 &&
                        Coeffcient_Efficiency_Y4_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y4_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y4_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb xyxs setMargin">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第五年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y5_Amount > 60 &&
                        Coeffcient_Efficiency_Y5_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y5_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y5_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb xyxs setMargin" v-if="showPeriod >= 6">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第六年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y6_Amount > 60 &&
                        Coeffcient_Efficiency_Y6_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y6_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y6_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb xyxs setMargin" v-if="showPeriod >= 7">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第七年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y7_Amount > 60 &&
                        Coeffcient_Efficiency_Y7_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y7_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y7_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>

              <div class="t-a-l xyxs" v-if="showPeriod >= 8">
                <div class="df-ac-jsb xyxs setMargin">
                  <el-col :span="10" class="minWidth">
                    <p class="font14">第八年</p>
                  </el-col>
                  <el-col :span="14">
                    <el-input
                      :class="
                        Coeffcient_Efficiency_Y8_Amount > 60 &&
                        Coeffcient_Efficiency_Y8_Amount < 80
                          ? 'grayColor'
                          : Coeffcient_Efficiency_Y8_Amount >= 80
                          ? 'greenColor'
                          : 'redcolor'
                      "
                      readonly
                      v-model="Coeffcient_Efficiency_Y8_Amount"
                    >
                      <!-- <template slot="append">%</template> -->
                    </el-input>
                  </el-col>
                </div>
              </div>
            </el-card>
          </el-col>

          <!-- 项目回本时效 -->
          <!-- <el-col :sm="24" :md="12" :lg="16" :xl="5">
          <el-card class="box-card custom_card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">EMC项目年净收</p>
              <p></p>
            </div>

            <div class="t-a-l">
              <div class="df-ac-jsb mg-b-10">
                <el-col :span="5" class="">
                  <p class="font14"></p>
                </el-col>
                <el-col :span="8">
                  <p class="font14 pd-l-10">净收入</p>
                </el-col>
                <el-col :span="9">
                  <p class="font14 pd-l-10">年末余额</p>
                </el-col>
              </div>
            </div>

            <div class="t-a-l">
              <div class="df-ac-jsb setMargin">
                <el-col :span="5" class="">
                  <p class="font14">第一年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      typeof HVACEMC_Commission_NetIncome_Y1 === 'string' &&
                      HVACEMC_Commission_NetIncome_Y1.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y1"
                  >
                    <template slot="prepend"> ￥ </template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      typeof HVACEMC_Commission_EndingBalance_Y1 === 'string' &&
                      HVACEMC_Commission_EndingBalance_Y1.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y1"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin">
                <el-col :span="5" class="">
                  <p class="font14">第二年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y2.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y2"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y2.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y2"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin">
                <el-col :span="5" class="">
                  <p class="font14">第三年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y3.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y3"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y3.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y3"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin">
                <el-col :span="5" class="">
                  <p class="font14">第四年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y4.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y4"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y4.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y4"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin">
                <el-col :span="5" class="">
                  <p class="font14">第五年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y5.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y5"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y5.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y5"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin" v-if="showPeriod >= 6">
                <el-col :span="5" class="">
                  <p class="font14">第六年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y6.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y6"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y6.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y6"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin" v-if="showPeriod >= 7">
                <el-col :span="5" class="">
                  <p class="font14">第七年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y7.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y7"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y7.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y7"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb setMargin" v-if="showPeriod >= 8">
                <el-col :span="5" class="">
                  <p class="font14">第八年</p>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_NetIncome_Y8.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_NetIncome_Y8"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
                <el-col :span="9">
                  <el-input
                    class="pd0"
                    :class="
                      HVACEMC_Commission_EndingBalance_Y8.includes('-')
                        ? 'redcolor'
                        : 'greenColor'
                    "
                    readonly
                    v-model="HVACEMC_Commission_EndingBalance_Y8"
                  >
                    <template slot="prepend">￥</template>
                  </el-input>
                </el-col>
              </div>
            </div>
          </el-card>
        </el-col> -->

          <!-- 第二行 -->

          <el-col :sm="12" :md="8" :lg="8" :xl="4">
            <el-card class="box-card2">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l mg-t-6 els">
                  甲方EMC项目实际节能收益 ({{ form_share_period }}年)
                </p>
              </div>
              <div class="t-a-l">
                <el-input
                  class=""
                  v-model="HVACEMC_Owner_Savings_Total"
                  :disabled="setBtnShow"
                >
                  <template slot="append">￥</template>
                </el-input>
              </div>
            </el-card>
          </el-col>

          <el-col :sm="12" :md="8" :lg="8" :xl="4">
            <el-card class="box-card2">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l mg-t-6 els">昌恩EMC项目总营收</p>
              </div>
              <div class="t-a-l">
                <el-input
                  class=""
                  v-model="HVACEMC_CE_Revenue_Total"
                  :disabled="setBtnShow"
                >
                  <template slot="append">￥</template>
                </el-input>
              </div>
            </el-card>
          </el-col>

          <!-- <el-col :sm="12" :md="12" :lg="6" :xl="6">
          <el-card class="box-card2">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l mg-t-6 els">昌恩EMC项目提成前总毛利</p>
            </div>
            <div class="t-a-l">
              <el-input
                class=""
                v-model="HVACEMC_CE_GrossProfitBC_Total"
                :disabled="setBtnShow"
              >
                <template slot="append">￥</template>
              </el-input>
            </div>
          </el-card>
        </el-col> -->

          <!-- <el-col :sm="12" :md="12" :lg="6" :xl="6">
          <el-card class="box-card2">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l mg-t-6 els">昌恩EMC项目实际总毛利</p>
            </div>
            <div class="t-a-l">
              <el-input
                class=""
                v-model="HVACEMC_CE_GrossProfit_Total"
                :disabled="setBtnShow"
              >
                <template slot="append">￥</template>
              </el-input>
              <p class="t-a-l endItemP">
                ({{
                  HVACEMC_CE_GrossProfit_Margin
                    ? HVACEMC_CE_GrossProfit_Margin + '%'
                    : 'NaN%'
                }})
              </p>
            </div>
          </el-card>
        </el-col> -->
        </el-row>
      </div>

      <!-- 3 -->
      <!-- <h3>硬件买断模式项目回报测算</h3> -->
      <div
        class="itemContainer3"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <h3>硬件买断模式项目回报测算</h3>
        <el-row :gutter="12" class="row-box">
          <el-col :sm="24" :md="9" :lg="9" :xl="10" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els">昌恩项目售价</p>

                <el-button
                  v-if="showBtn_Annual"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseItemHVACBO_CE_SellingPrice"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel_HVACBO_CE_SellingPrice_Phase_1_P"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm_HVACBO_CE_SellingPrice_Phase_1_P"
                  ></el-button>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="5" class="">
                    <p class="font14 els">总额：</p>
                  </el-col>

                  <el-col :span="16">
                    <el-input
                      class=""
                      v-model="HVACBO_CE_SellingPrice"
                      :disabled="showBtn_Annual"
                    >
                      <template slot="append">￥</template></el-input
                    >
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <p class="font14 els">首款比例<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      ref="btnHVACBO_CE_SellingPrice_Phase_1_P"
                      v-model="filterLoan_HVACBO_CE_SellingPrice_Phase_1_P"
                      :disabled="showBtn_Annual"
                      placeholder="必填大于0"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACBO_CE_SellingPrice_Phase_1">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <p class="font14 els">二款比例<i class="red">*</i></p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="filterLoan_HVACBO_CE_SellingPrice_Phase_2_P"
                      :disabled="showBtn_Annual"
                      placeholder="必填大于0"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACBO_CE_SellingPrice_Phase_2">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <p class="font14 els">三款比例</p>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      v-model="filterLoan_HVACBO_CE_SellingPrice_Phase_3_P"
                      disabled
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="10">
                    <el-input readonly v-model="HVACBO_CE_SellingPrice_Phase_3">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :sm="24" :md="6" :lg="6" :xl="4" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">昌恩运维收入</p>

                <el-button
                  v-if="showBtn_OMI"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseItemHVACBO_CE_OMI_Annual"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel_HVACBO_CE_OMI_Annual"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm_HVACBO_CE_OMI_Annual"
                  ></el-button>
                </div>
              </div>

              <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
                <el-col :span="9" class="">
                  <p class="font14 t-a-l">年均：</p>
                </el-col>
                <el-col :span="15" class="df-ac-jsb">
                  <el-tooltip
                    effect="dark"
                    :content="HVACBO_CE_OMI_Annual"
                    placement="top"
                  >
                    <el-input
                      ref="btnHVACBO_CE_OMI_Annual_Total"
                      v-model="HVACBO_CE_OMI_Annual"
                      :disabled="showBtn_OMI"
                    >
                      <template slot="append">￥</template>
                    </el-input>
                  </el-tooltip>
                </el-col>
              </div>

              <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
                <el-col :span="10" class="">
                  <el-tooltip
                    effect="dark"
                    :content="`${form_share_period}年总额`"
                    placement="bottom"
                  >
                    <p class="font14 t-a-l els">
                      {{ form_share_period }}年总额：
                    </p>
                  </el-tooltip>
                </el-col>
                <el-col :span="15">
                  <el-tooltip
                    v-if="HVACBO_CE_OMI_Annual_Total"
                    effect="dark"
                    :content="HVACBO_CE_OMI_Annual_Total"
                    placement="bottom"
                  >
                    <el-input readonly v-model="HVACBO_CE_OMI_Annual_Total">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-tooltip>
                </el-col>
              </div>
            </el-card>
          </el-col>

          <el-col :sm="24" :md="9" :lg="9" :xl="10" style="margin: 6px 0">
            <el-card class="box-card">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">昌恩项目销售提成</p>

                <el-button
                  v-if="showBtn_HVACBO"
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="baseItemHVACBO_Commission_Agents"
                  :disabled="disabledAllBtn"
                ></el-button>
                <div v-else class="df-normal">
                  <el-button
                    type="info"
                    icon="el-icon-close"
                    circle
                    size="mini"
                    @click="cancel_HVACBO_Commission_Agents"
                  ></el-button>
                  <el-button
                    type="success"
                    icon="el-icon-check"
                    circle
                    size="mini"
                    @click="confirm_HVACBO_Commission_Agents"
                  ></el-button>
                </div>
              </div>

              <div class="t-a-l">
                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <el-tooltip effect="dark" content="商务包" placement="top">
                      <p class="font14 els">商务包：</p>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-input
                      :disabled="showBtn_HVACBO"
                      ref="HVACBO_Commission_P_Agents"
                      v-model="HVACBO_Commission_P_Agents"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="11">
                    <el-input readonly v-model="HVACBO_Commission_Agents_Total">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <el-tooltip effect="dark" content="销售包" placement="top">
                      <p class="font14 els">销售包：</p>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-input
                      v-model="HVACBO_Commission_P_Sales"
                      :disabled="showBtn_HVACBO"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="11">
                    <el-input readonly v-model="HVACBO_Commission_Sales_Total">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <!-- <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <el-tooltip effect="dark" content="支持包" placement="top">
                      <p class="font14 els">支持包：</p>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-input
                      v-model="HVACBO_Commission_P_Supports"
                      :disabled="showBtn_HVACBO"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="11">
                    <el-input
                      readonly
                      v-model="HVACBO_Commission_Supports_Total"
                    >
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div>

                <div class="df-ac-jsb hvacemc_bsm_cebsp">
                  <el-col :span="6" class="">
                    <el-tooltip
                      effect="dark"
                      content="总提成"
                      placement="bottom"
                    >
                      <p class="font14 els">总提成：</p>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-input v-model="HVACBO_Commission_P_Total" readonly>
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>

                  <el-col :span="11">
                    <el-input readonly v-model="HVACBO_Commission_Total_Total">
                      <template slot="append">￥</template>
                    </el-input>
                  </el-col>
                </div> -->
              </div>
            </el-card>
          </el-col>

          <!-- <el-col :sm="12" :md="8" :lg="4" :xl="5" style="margin: 6px 0" class="">
          <div class="flex-direction-column">
            <el-card class="mg-b-10" style="height: 125px">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">昌恩合同总营收</p>
              </div>

              <div class="df-ac-jsb">
                <el-col :span="24">
                  <el-input
                    readonly
                    class="totalContractRevenue"
                    v-model="HVACBO_CE_Revenue_Total"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-col>
              </div>
            </el-card>

            <el-card class="" style="height: 125px">
              <div slot="header" class="df-ac-jsb clearfix">
                <p class="t-a-l els mg-t-6">昌恩项目提成前总毛利</p>
              </div>

              <div class="df-ac-jsb">
                <el-col :span="24">
                  <el-input
                    readonly
                    class="totalContractRevenue"
                    v-model="HVACBO_CE_GrossProfitBC_Total"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-col>
              </div>
            </el-card>
          </div>
        </el-col> -->

          <!-- <el-col :sm="12" :md="8" :lg="5" :xl="4" style="margin: 6px 0">
          <el-card class="box-card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">昌恩项目实际总毛利</p>
            </div>
            <el-col :span="24" class="mg-t-30">
              <p class="t-a-c">
                <span style="color: gray">￥</span
                >{{ HVACBO_CE_GrossProfit_Total }}
              </p>
            </el-col>
            <el-col :span="24" class="mg-t-10">
              <p class="t-a-c">({{ HVACBO_CE_GrossProfit_Margin + '%' }})</p>
            </el-col>
          </el-card>
        </el-col> -->

          <!-- 第二行 -->
          <!-- <el-col :sm="24" :md="8" :lg="8" :xl="8" style="margin: 6px 0">
          <el-card class="box-card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els">代理方项目售价</p>

              <el-button
                v-if="showBtn_Agent"
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="hardwareHVACBO_Agent_SellingPrice_Phase_1_P"
                :disabled="disabledAllBtn"
              ></el-button>
              <div v-else class="df-normal">
                <el-button
                  type="info"
                  icon="el-icon-close"
                  circle
                  size="mini"
                  @click="cancel_Agent"
                ></el-button>
                <el-button
                  type="success"
                  icon="el-icon-check"
                  circle
                  size="mini"
                  @click="confirm_Agent"
                ></el-button>
              </div>
            </div>

            <div class="t-a-l">
              <div class="df-ac-jsb hvacemc_bsm_cebsp">
                <el-col :span="5" class="">
                  <p class="font14 els">总额：</p>
                </el-col>

                <el-col :span="16">
                  <el-input
                    class="totalPrice"
                    v-model="HVACBO_Agent_SellingPrice"
                    :disabled="setBtnShow"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb hvacemc_bsm_cebsp">
                <el-col :span="6" class="">
                  <p class="font14 els">首款比例<i class="red">*</i></p>
                </el-col>
                <el-col :span="8">
                  <el-input
                    oninput="value=value.replace(/[^\d.]/g,'')"
                    ref="btnHVACBO_Agent_SellingPrice_Phase_1_P"
                    v-model="filterLoan_HVACBO_Agent_SellingPrice_Phase_1_P"
                    :disabled="showBtn_Agent"
                    placeholder="必填大于0"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-col>

                <el-col :span="10">
                  <el-input
                    readonly
                    v-model="HVACBO_Agent_SellingPrice_Phase_1"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb hvacemc_bsm_cebsp">
                <el-col :span="6" class="">
                  <p class="font14 els">二款比例<i class="red">*</i></p>
                </el-col>
                <el-col :span="8">
                  <el-input
                    oninput="value=value.replace(/[^\d.]/g,'')"
                    v-model="filterLoan_HVACBO_Agent_SellingPrice_Phase_2_P"
                    :disabled="showBtn_Agent"
                    placeholder="必填大于0"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-col>

                <el-col :span="10">
                  <el-input
                    readonly
                    v-model="HVACBO_Agent_SellingPrice_Phase_2"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb hvacemc_bsm_cebsp">
                <el-col :span="6" class="">
                  <p class="font14 els">三款比例</p>
                </el-col>
                <el-col :span="8">
                  <el-input
                    oninput="value=value.replace(/[^\d.]/g,'')"
                    v-model="filterLoan_HVACBO_Agent_SellingPrice_Phase_3_P"
                    disabled
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-col>

                <el-col :span="10">
                  <el-input
                    readonly
                    v-model="HVACBO_Agent_SellingPrice_Phase_3"
                  >
                    <template slot="append">￥</template>
                  </el-input>
                </el-col>
              </div>
            </div>
          </el-card>
        </el-col> -->

          <!-- <el-col :sm="12" :md="7" :lg="6" :xl="4" style="margin: 6px 0">
          <el-card class="box-card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">代理运维收入</p>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
              <el-col :span="9" class="">
                <p class="font14 t-a-l">年均：</p>
              </el-col>
              <el-col :span="15">
                <el-input readonly v-model="HVACBO_Agent_OMI_Annual">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
              <el-col :span="9" class="">
                <p class="font14 t-a-l els">6年总额：</p>
              </el-col>
              <el-col :span="15">
                <el-input readonly v-model="HVACBO_Agent_OMI_Annual_Total">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <br />
            <br />

            <el-col :span="24">
              <div class="font12">**根据项目用电量与运维服务包计算</div>
            </el-col>
          </el-card>
        </el-col> -->

          <!-- <el-col :sm="12" :md="6" :lg="5" :xl="3" style="margin: 6px 0">
          <el-card class="box-card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">代理方项目总营收</p>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
              <el-col :span="24">
                <p class="pd-tb10 t-a-l">
                  <span class="gray">￥</span>{{ HVACBO_Agent_Revenue_Total }}
                </p>
              </el-col>
            </div>

            <div class="">
              <el-col :span="24" class="">
                <p class="font14 t-a-l pd-tb20">代理方总毛利</p>
              </el-col>
              <el-col :span="24" style="padding-right: 0">
                <p class="pd-tb10 t-a-l">
                  ￥{{ HVACBO_Agent_GrossProfit_Total }} ({{
                    HVACBO_Agent_GrossProfit_Margin + '%'
                  }})
                </p>
              </el-col>
            </div>
          </el-card>
        </el-col> -->

          <!-- <el-col :sm="12" :md="12" :lg="12" :xl="6" style="margin: 6px 0">
          <el-card class="box-card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">甲方项目节能年均收益预测</p>
            </div>

            <div class="t-a-l">
              <div class="df-ac-jsb">
                <el-col :span="8" class="">
                  <p class="font14 els">昌恩直售收益：</p>
                </el-col>

                <el-col :span="7">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="HVACBO_Owner_Savings_Annual_CE"
                    placement="top"
                  >
                    <el-input
                      class="pd0"
                      v-model="HVACBO_Owner_Savings_Annual_CE"
                      :disabled="setBtnShow"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-tooltip>
                </el-col>

                <el-col :span="6">
                  <p class="font14 els">回本时限：</p>
                </el-col>

                <el-col :span="5">
                  <el-input class="pd0" readonly v-model="HVACBO_Owner_CE_BEP">
                    <template slot="append">年</template>
                  </el-input>
                </el-col>
              </div>

              <div class="df-ac-jsb">
                <el-col :span="8" class="">
                  <p class="font14 els">代理销售收益：</p>
                </el-col>

                <el-col :span="7">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="HVACBO_Owner_Savings_Annual_Agent"
                    placement="bottom"
                  >
                    <el-input
                      class="pd0"
                      v-model="HVACBO_Owner_Savings_Annual_Agent"
                      :disabled="setBtnShow"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-tooltip>
                </el-col>

                <el-col :span="6">
                  <p class="font14 els">回本时限：</p>
                </el-col>

                <el-col :span="5">
                  <el-input
                    class="pd0"
                    readonly
                    v-model="HVACBO_Owner_Agent_BEP"
                  >
                    <template slot="append">年</template>
                  </el-input>
                </el-col>
              </div>
            </div>
          </el-card>
        </el-col> -->

          <!-- <el-col :sm="12" :md="12" :lg="12" :xl="5" style="margin: 6px 0">
          <el-card class="box-card">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">甲方项目节能6年实际毛收益</p>
            </div>

            <div class="t-a-l">
              <div class="df-ac-jsb">
                <el-col :span="14" class="">
                  <p class="font14 els">昌恩直售实际收益</p>
                </el-col>

                <el-col :span="10">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="HVACBO_Owner_Savings_Total"
                    placement="top"
                  >
                    <el-input
                      class="pd0"
                      v-model="HVACBO_Owner_Savings_Total"
                      :disabled="setBtnShow"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-tooltip>
                </el-col>
              </div>
            </div>

            <div class="t-a-l">
              <div class="" style="display: flex; align-items: center">
                <el-col :span="14" class="">
                  <p class="font14 els">代理销售实际收益</p>
                </el-col>

                <el-col :span="10">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="HVACBO_Agent_Savings_Total"
                    placement="bottom"
                  >
                    <el-input
                      class="pd0"
                      v-model="HVACBO_Agent_Savings_Total"
                      :disabled="setBtnShow"
                    >
                      <template slot="prepend">￥</template>
                    </el-input>
                  </el-tooltip>
                </el-col>
              </div>
            </div>
          </el-card>
        </el-col> -->
        </el-row>
      </div>
    </div>

    <div v-else>
      <mobileBudgetSheet></mobileBudgetSheet>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { getById, add } from "@/api/home/index";
import { symbolOfRMB, removeSymbolOfRMB } from "@/utils/symbolOfRMB";
import { getTodayTime } from "@/utils/time";
import moment from "moment";
import myForm from "@/components/elementComponents/form/index.vue";
import modelOfContract from "@/components/budgetSheet/modelOfContract.vue";
import hardwareBuyoutMode from "@/components/budgetSheet/hardwareBuyoutMode.vue";
import mobileBudgetSheet from "@/views/mobile/budgetSheet.vue";

export default {
  components: {
    myForm,
    modelOfContract,
    hardwareBuyoutMode,
    mobileBudgetSheet,
  },

  data() {
    return {
      permissionAccess: false,
      setBtnShow: true,
      title: "1",
      disabledAllBtn: false,
      setDisable: false,
      loading: false,
      isInputInvalid: false, // 是否显示校验文字
      inputErrorMessage: "", // 校验文字
      placeholder: "",
      name: "",
      metadata: [],
      // 项目暖通系统年用电量
      HVAC_EnergyConsumption_Annual: "", //tempContent
      orginContent_HVAC_EnergyConsumption_Annual: "",

      // 年均节能率
      HVAC_AveragePSR_Annual: "",
      orginContent_HVAC_AveragePSR_Annual: "",

      // 年均节电量（度）
      HVAC_PowerSavings_Annual: "",
      // 年度减碳量
      HVAC_CarbonReduction_Annual: "",
      // 月均节电量（度）
      HVAC_PowerSavings_Monthly: "",

      // 电费单价
      Power_UnitPrice: "",
      orginContent_Power_UnitPrice: "",

      // 项目年均总节电费
      HVAC_Savings_Total: "",

      // 建设毛成本
      Cost_Construction: "",
      orginContent_Cost_Construction: "",

      // 项目运维成本
      Cost_OM_Anuual: "",
      orginContent_Cost_OM_Anuual: "",

      // 6年运维成本
      Cost_OM_Anuual_Total: "",

      // 项目贷款情况,默认0
      Loan_Status: 0,
      orginContent_Loan_Status: 0,

      // 项目贷款额
      Loan_Amount: "",
      orginContent_Loan_Amount: "",

      // 贷款年利率
      Loan_InterestRate_Annual: "",
      orginContent_Loan_InterestRate_Annual: "",

      // 贷款年限
      Loan_Term: "",
      orginContent_Loan_Term: "",
      // 先息后本；年利息额
      Loan_Intrest_Annual: "",
      // 贷款利息总额
      Loan_Interest_Total: "",

      showBtn1: true,
      showBtn2: true,
      showBtn3: true,
      showBtn4: true,
      showBtn5: true,
      showBtn6: true,
      showBtn7: true,
      showBtn8: true,
      showBtn9: true,
      showBtn10: true,
      showBtn11: true,
      showGrey: false,

      // 第二个能源管理合同模式 (EMC) 项目回报测算
      // 项目分成模式选择
      HVACEMC_BSM_CEBSP: 0, // 项目分成模式选择--固定0 浮动1
      // HVACEMC_BSM_CEBSP_FP: '', // 项目分成模式选择--昌恩年均分成比例
      // orginContent_HVACEMC_BSM_CEBSP_FP: '',
      // HVACEMC_BSM_CEBSP_Price: '', // 项目分成模式选择-- 固定比例计算结果

      //浮动比例
      HVACEMC_BSM_CEBSP_P1: "", // 昌恩首年分成比例
      orginContent_HVACEMC_BSM_CEBSP_P1: "",
      HVACEMC_BSM_CEBSP_P1_Price: "", //昌恩其余分成比例--结果

      HVACEMC_BSM_CEBSP_P2: "", // 昌恩其余分成比例
      orginContent_HVACEMC_BSM_CEBSP_P2: "",
      HVACEMC_BSM_CEBSP_P2_Price: "", //昌恩其余分成比例--结果

      // 分成年限选择：
      form_share_period: "7",
      HVACEMC_ContractTerm_Year: 7,
      // 新字段：昌恩项目分成模式
      HVACEMC_BSM_CE_Y1_Rate: null,
      HVACEMC_BSM_CE_Y2_Rate: null,
      HVACEMC_BSM_CE_Y3_Rate: null,
      HVACEMC_BSM_CE_Y4_Rate: null,
      HVACEMC_BSM_CE_Y5_Rate: null,
      HVACEMC_BSM_CE_Y6_Rate: null,
      HVACEMC_BSM_CE_Y7_Rate: null,
      HVACEMC_BSM_CE_Y8_Rate: null,
      orginContent_HVACEMC_BSM_CE_Y1_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y2_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y3_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y4_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y5_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y6_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y7_Rate: "",
      orginContent_HVACEMC_BSM_CE_Y8_Rate: "",

      HVACEMC_BSM_CE_Y1_Amount: "",
      HVACEMC_BSM_CE_Y2_Amount: "",
      HVACEMC_BSM_CE_Y3_Amount: "",
      HVACEMC_BSM_CE_Y4_Amount: "",
      HVACEMC_BSM_CE_Y5_Amount: "",
      HVACEMC_BSM_CE_Y6_Amount: "",
      HVACEMC_BSM_CE_Y7_Amount: "",
      HVACEMC_BSM_CE_Y8_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y1_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y2_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y3_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y4_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y5_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y6_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y7_Amount: "",
      orginContent_HVACEMC_BSM_CE_Y8_Amount: "",

      showPeriod: 7,
      // 新字段：end

      // 预测效益系数
      Coeffcient_Efficiency: "",
      //分成系数
      Coefficient_Commission: "",
      // 预测效益系数新字段
      Coeffcient_Efficiency_Y1_Amount: "",
      Coeffcient_Efficiency_Y2_Amount: "",
      Coeffcient_Efficiency_Y3_Amount: "",
      Coeffcient_Efficiency_Y4_Amount: "",
      Coeffcient_Efficiency_Y5_Amount: "",
      Coeffcient_Efficiency_Y6_Amount: "",
      Coeffcient_Efficiency_Y7_Amount: "",
      Coeffcient_Efficiency_Y8_Amount: "",

      // 项目回本时效
      HVACEMC_BEP: "",
      HVACEMC_BSP: "",

      // 项目提成比例
      showBtn_CommissionRate: true,
      HVACEMC_CommissionRate_Agents: "",
      HVACEMC_CommissionRate_Sales: "",
      HVACEMC_CommissionRate_Supports: "",
      HVACEMC_CommissionRate_Total: "",
      orginContent_HVACEMC_CommissionRate_Agents: "",
      orginContent_HVACEMC_CommissionRate_Sales: "",
      orginContent_HVACEMC_CommissionRate_Supports: "",
      orginContent_HVACEMC_CommissionRate_Total: "",

      // 项目预测提成金额
      HVACEMC_Commission_Sales_Total: "",
      HVACEMC_Commission_Sales_AA: "",
      HVACEMC_Commission_Sales_MA: "",
      HVACEMC_Commission_Supports_Total: "",
      HVACEMC_Commission_Supports_AA: "",
      HVACEMC_Commission_Supports_MA: "",
      HVACEMC_Commission_Total_Total: "",
      HVACEMC_Commission_Total_AA: "",
      HVACEMC_Commission_Total_MA: "",
      // 项目预测提成金额 新字段
      HVACEMC_Commission_Agents_Y1_Amount: "",
      HVACEMC_Commission_Agents_Y2_Amount: "",
      HVACEMC_Commission_Agents_Y3_Amount: "",
      HVACEMC_Commission_Agents_Y4_Amount: "",
      HVACEMC_Commission_Agents_Y5_Amount: "",
      HVACEMC_Commission_Agents_Y6_Amount: "",
      HVACEMC_Commission_Agents_Y7_Amount: "",
      HVACEMC_Commission_Agents_Y8_Amount: "",

      HVACEMC_Commission_Sales_Y1_Amount: "",
      HVACEMC_Commission_Sales_Y2_Amount: "",
      HVACEMC_Commission_Sales_Y3_Amount: "",
      HVACEMC_Commission_Sales_Y4_Amount: "",
      HVACEMC_Commission_Sales_Y5_Amount: "",
      HVACEMC_Commission_Sales_Y6_Amount: "",
      HVACEMC_Commission_Sales_Y7_Amount: "",
      HVACEMC_Commission_Sales_Y8_Amount: "",

      HVACEMC_Commission__Supports_Y1_Amount: "",
      HVACEMC_Commission__Supports_Y2_Amount: "",
      HVACEMC_Commission__Supports_Y3_Amount: "",
      HVACEMC_Commission__Supports_Y4_Amount: "",
      HVACEMC_Commission__Supports_Y5_Amount: "",
      HVACEMC_Commission__Supports_Y6_Amount: "",
      HVACEMC_Commission__Supports_Y7_Amount: "",
      HVACEMC_Commission__Supports_Y8_Amount: "",

      HVACEMC_Commission__Total_Y1_Amount: "",
      HVACEMC_Commission__Total_Y2_Amount: "",
      HVACEMC_Commission__Total_Y3_Amount: "",
      HVACEMC_Commission__Total_Y4_Amount: "",
      HVACEMC_Commission__Total_Y5_Amount: "",
      HVACEMC_Commission__Total_Y6_Amount: "",
      HVACEMC_Commission__Total_Y7_Amount: "",
      HVACEMC_Commission__Total_Y8_Amount: "",

      // 昌恩EMC项目年净收 新字段
      // 净收入
      HVACEMC_Commission_NetIncome_Y1: "",
      HVACEMC_Commission_NetIncome_Y2: "",
      HVACEMC_Commission_NetIncome_Y3: "",
      HVACEMC_Commission_NetIncome_Y4: "",
      HVACEMC_Commission_NetIncome_Y5: "",
      HVACEMC_Commission_NetIncome_Y6: "",
      HVACEMC_Commission_NetIncome_Y7: "",
      HVACEMC_Commission_NetIncome_Y8: "",
      // 年末余额
      HVACEMC_Commission_EndingBalance_Y1: "",
      HVACEMC_Commission_EndingBalance_Y2: "",
      HVACEMC_Commission_EndingBalance_Y3: "",
      HVACEMC_Commission_EndingBalance_Y4: "",
      HVACEMC_Commission_EndingBalance_Y5: "",
      HVACEMC_Commission_EndingBalance_Y6: "",
      HVACEMC_Commission_EndingBalance_Y7: "",
      HVACEMC_Commission_EndingBalance_Y8: "",

      // 甲方EMC项目实际节能收益
      HVACEMC_Owner_Savings_Total: "",
      // 昌恩EMC项目总营收
      HVACEMC_CE_Revenue_Total: "",
      // 昌恩EMC项目提成前总毛利
      HVACEMC_CE_GrossProfitBC_Total: "",
      // 昌恩EMC项目实际总毛利
      HVACEMC_CE_GrossProfit_Total: "",
      HVACEMC_CE_GrossProfit_Margin: "",

      showBtn_HVACEMC_BSM_CEBSP: true,
      monthly: "月均",
      year: "年均",
      total: "总值",

      // 三、硬件买断模式项目回报测算
      // 昌恩项目售价
      HVACBO_CE_SellingPrice: "",
      HVACBO_CE_SellingPrice_Phase_1_P: "",
      HVACBO_CE_SellingPrice_Phase_2_P: "",
      HVACBO_CE_SellingPrice_Phase_3_P: "",
      HVACBO_CE_SellingPrice_Phase_1: "",
      HVACBO_CE_SellingPrice_Phase_2: "",
      HVACBO_CE_SellingPrice_Phase_3: "",

      orginContent_HVACBO_CE_SellingPrice: "",
      orginContent_HVACBO_CE_SellingPrice_Phase_1_P: "",
      orginContent_HVACBO_CE_SellingPrice_Phase_2_P: "",
      orginContent_HVACBO_CE_SellingPrice_Phase_3_P: "",

      // 昌恩运维收入
      HVACBO_CE_OMI_Annual: "",
      HVACBO_CE_OMI_Annual_Total: "",
      orginContent_HVACBO_CE_OMI_Annual: "",

      // 昌恩项目销售提成
      HVACBO_Commission_P_Agents: "", //商务包比例
      HVACBO_Commission_P_Sales: "",
      HVACBO_Commission_P_Supports: "",
      HVACBO_Commission_P_Total: "",
      orginContent_HVACBO_Commission_P_Agents: "",
      orginContent_HVACBO_Commission_P_Sales: "",
      orginContent_HVACBO_Commission_P_Supports: "",
      orginContent_HVACBO_Commission_P_Total: "",

      HVACBO_Commission_Sales_Total: "",
      HVACBO_Commission_Supports_Total: "",
      HVACBO_Commission_Total_Total: "",
      HVACBO_Commission_Agents_Total: "", // 商务包金额

      // 昌恩合同总营收
      HVACBO_CE_Revenue_Total: "",
      // 昌恩项目提成前总毛利
      HVACBO_CE_GrossProfitBC_Total: "",
      // 昌恩项目实际总毛利
      HVACBO_CE_GrossProfit_Total: "",
      HVACBO_CE_GrossProfit_Margin: "",

      // 代理方项目售价
      HVACBO_Agent_SellingPrice: "",
      HVACBO_Agent_SellingPrice_Phase_1_P: "",
      HVACBO_Agent_SellingPrice_Phase_2_P: "",
      HVACBO_Agent_SellingPrice_Phase_3_P: "",
      HVACBO_Agent_SellingPrice_Phase_1: "",
      HVACBO_Agent_SellingPrice_Phase_2: "",
      HVACBO_Agent_SellingPrice_Phase_3: "",

      orginContent_HVACBO_Agent_SellingPrice: "",
      orginContent_HVACBO_Agent_SellingPrice_Phase_1_P: "",
      orginContent_HVACBO_Agent_SellingPrice_Phase_2_P: "",
      orginContent_HVACBO_Agent_SellingPrice_Phase_3_P: "",

      // 代理运维收入
      HVACBO_Agent_OMI_Annual: "",
      HVACBO_Agent_OMI_Annual_Total: "",
      orginContent_HVACBO_Agent_OMI_Annual: "",

      // 代理方项目总营收
      HVACBO_Agent_Revenue_Total: "",
      // 代理方项目总毛利
      HVACBO_Agent_GrossProfit_Total: "",
      HVACBO_Agent_GrossProfit_Margin: "",
      // 甲方项目节能年均收益预测
      HVACBO_Owner_Savings_Annual_CE: "",
      HVACBO_Owner_CE_BEP: "",
      HVACBO_Owner_Savings_Annual_Agent: "",
      HVACBO_Owner_Agent_BEP: "",
      // 甲方项目节能6年实际毛收益
      HVACBO_Owner_Savings_Total: 0,
      HVACBO_Agent_Savings_Total: 0,
      //---
      showBtn_Annual: true,
      showBtn_Agent: true,
      // 昌恩运维收入
      showBtn_OMI: true,
      // 昌恩项目销售提成
      showBtn_HVACBO: true,
      // 代理运维收入
      showBtn_AgentOMI: true,
    };
  },
  computed: {
    ...mapState(["saveInput"]),
    // 年均节能率
    // filterHVAC_AveragePSR_Annual: {
    //   get () {
    //     return Math.round(this.HVAC_AveragePSR_Annual * 100)
    //   },
    //   set (value) {
    //     console.log('年均节能率', value)
    //     console.log('年均节能率', this.HVAC_AveragePSR_Annual)
    //     this.HVAC_AveragePSR_Annual = value / 100
    //   }
    // },
    filterLoan_InterestRate_Annual: {
      get() {
        return this.Loan_InterestRate_Annual * 100;
      },
      set(value) {
        this.Loan_InterestRate_Annual = value / 100;
      },
    },

    // 二、项目分成模式选择：
    // 固定比例

    //三、 昌恩项目售价
    filterLoan_HVACBO_CE_SellingPrice_Phase_1_P: {
      get() {
        // return Math.round(this.HVACBO_CE_SellingPrice_Phase_1_P * 100)
        if (this.HVACBO_CE_SellingPrice_Phase_1_P !== "") {
          return this.HVACBO_CE_SellingPrice_Phase_1_P * 100;
        } else {
          return this.HVACBO_CE_SellingPrice_Phase_1_P;
        }
      },
      set(value) {
        this.HVACBO_CE_SellingPrice_Phase_1_P = value / 100;
      },
    },
    filterLoan_HVACBO_CE_SellingPrice_Phase_2_P: {
      get() {
        // return Math.round(this.HVACBO_CE_SellingPrice_Phase_2_P * 100)
        if (this.HVACBO_CE_SellingPrice_Phase_2_P !== "") {
          return Math.round(this.HVACBO_CE_SellingPrice_Phase_2_P * 100);
        } else {
          return this.HVACBO_CE_SellingPrice_Phase_2_P;
        }
      },
      set(value) {
        this.HVACBO_CE_SellingPrice_Phase_2_P = value / 100;
      },
    },
    filterLoan_HVACBO_CE_SellingPrice_Phase_3_P: {
      get() {
        return Math.round(this.HVACBO_CE_SellingPrice_Phase_3_P * 100);
      },
      set(value) {
        this.HVACBO_CE_SellingPrice_Phase_3_P = value / 100;
      },
    },

    // 代理方项目售价
    filterLoan_HVACBO_Agent_SellingPrice_Phase_1_P: {
      get() {
        // return Math.round(this.HVACBO_Agent_SellingPrice_Phase_1_P * 100)
        if (this.HVACBO_Agent_SellingPrice_Phase_1_P !== "") {
          return Math.round(this.HVACBO_Agent_SellingPrice_Phase_1_P * 100);
        } else {
          return this.HVACBO_Agent_SellingPrice_Phase_1_P;
        }
      },
      set(value) {
        this.HVACBO_Agent_SellingPrice_Phase_1_P = value / 100;
      },
    },

    filterLoan_HVACBO_Agent_SellingPrice_Phase_2_P: {
      get() {
        // return Math.round(this.HVACBO_Agent_SellingPrice_Phase_2_P * 100)
        if (this.HVACBO_Agent_SellingPrice_Phase_2_P !== "") {
          return Math.round(this.HVACBO_Agent_SellingPrice_Phase_2_P * 100);
        } else {
          return this.HVACBO_Agent_SellingPrice_Phase_2_P;
        }
      },
      set(value) {
        this.HVACBO_Agent_SellingPrice_Phase_2_P = value / 100;
      },
    },

    filterLoan_HVACBO_Agent_SellingPrice_Phase_3_P: {
      get() {
        return Math.round(this.HVACBO_Agent_SellingPrice_Phase_3_P * 100);
      },
      set(value) {
        this.HVACBO_Agent_SellingPrice_Phase_3_P = value / 100;
      },
    },
  },
  mounted() {
    this.title = this.$route.query.title ? "预算详情" : "新增预算";
    console.log("新增预算传递的名字", this.$route.query.name);
    if (this.$route.query.title) {
      this.getDetail(this.$route.query.id);
      console.log("预算详情，调接口获取详情");
      // this.$nextTick(() => {
      //   // 禁用所有编辑按钮
      //   this.disabledAllBtn = true
      // })
    } else {
      this.name = this.$route.query.name;
      // this.disabledAllBtn = false
    }

    // 判断是否权限菜单跳转过来
    console.log("this.$route.query.permission", this.$route.query.permission);
    this.permissionAccess = this.$route.query.permission;
  },
  methods: {
    async getDetail(id) {
      try {
        const res = await getById(id);
        this.metadata = res.data.data;
        console.log("获取详情", res.data.data);
        this.dumpData(res.data.data);
      } catch (error) {
        console.log("接口报错", error);
      }
    },

    // 回显数据
    dumpData(data) {
      this.name = data.name;
      // 一、项目暖通系统年用电量
      this.HVAC_EnergyConsumption_Annual = symbolOfRMB(
        data.HVAC_EnergyConsumption_Annual
      );
      console.log("千位", data.HVAC_EnergyConsumption_Annual);
      console.log("千位 类型", typeof this.HVAC_EnergyConsumption_Annual);

      this.orginContent_HVAC_EnergyConsumption_Annual =
        data.HVAC_EnergyConsumption_Annual;
      console.log(
        "原来项目暖通系统年用电量的值",
        this.orginContent_HVAC_EnergyConsumption_Annual
      );

      // 年均节能率
      this.HVAC_AveragePSR_Annual = data.HVAC_AveragePSR_Annual;
      this.orginContent_HVAC_AveragePSR_Annual = data.HVAC_AveragePSR_Annual;

      // 年均节电量（度）
      this.HVAC_PowerSavings_Annual = symbolOfRMB(
        data.HVAC_PowerSavings_Annual
      );
      this.HVAC_CarbonReduction_Annual = symbolOfRMB(
        data.HVAC_CarbonReduction_Annual
      );
      // 月均节电量（度）
      this.HVAC_PowerSavings_Monthly = symbolOfRMB(
        data.HVAC_PowerSavings_Monthly
      );

      // 电费单价
      this.Power_UnitPrice = data.Power_UnitPrice;
      this.orginContent_Power_UnitPrice = data.Power_UnitPrice;

      // 项目年均总节电费
      this.HVAC_Savings_Total = symbolOfRMB(data.HVAC_Savings_Total);

      // 建设毛成本
      this.Cost_Construction = symbolOfRMB(data.Cost_Construction);
      this.orginContent_Cost_Construction = data.Cost_Construction;

      // 项目运维成本
      this.Cost_OM_Anuual = symbolOfRMB(data.Cost_OM_Anuual);
      this.orginContent_Cost_OM_Anuual = data.Cost_OM_Anuual;

      // 6年运维成本
      this.Cost_OM_Anuual_Total = symbolOfRMB(data.Cost_OM_Anuual_Total);

      // 项目贷款情况默认0
      this.Loan_Status = data.Loan_Status;
      this.showGrey = data.Loan_Status;
      this.orginContent_Loan_Status = data.Loan_Status;

      // 项目贷款额
      this.Loan_Amount = symbolOfRMB(data.Loan_Amount);
      this.orginContent_Loan_Amount = data.Loan_Amount;

      // 贷款年利率
      this.Loan_InterestRate_Annual = data.Loan_InterestRate_Annual;
      this.orginContent_Loan_InterestRate_Annual =
        data.Loan_InterestRate_Annual;

      // 贷款年限
      this.Loan_Term = data.Loan_Term;
      this.orginContent_Loan_Term = data.Loan_Term;
      // 先息后本；年利息额
      this.Loan_Intrest_Annual = symbolOfRMB(data.Loan_Intrest_Annual);
      // 贷款利息总额
      this.Loan_Interest_Total = symbolOfRMB(data.Loan_Interest_Total);

      // 二、项目分成模式选择

      this.HVACEMC_ContractTerm_Year = data.HVACEMC_ContractTerm_Year;
      // 循环设置属性值
      for (let i = 1; i <= 8; i++) {
        // 分成百分比
        const rateKey = `HVACEMC_BSM_CE_Y${i}_Rate`;
        this[rateKey] = data[rateKey];
        this[`orginContent_${rateKey}`] = data[rateKey];

        // 分成金额
        const amountKey = `HVACEMC_BSM_CE_Y${i}_Amount`;
        this[amountKey] = symbolOfRMB(data[amountKey]);
        if (data[amountKey] == 0) {
          // console.log('分成金额为0', data[amountKey])
          this[amountKey] = data[amountKey];
        }
      }

      // 预测效益系数
      this.Coeffcient_Efficiency = data.Coeffcient_Efficiency;
      //分成系数
      this.Coefficient_Commission = data.Coefficient_Commission;
      this.Coeffcient_Efficiency_Y1_Amount =
        data.Coeffcient_Efficiency_Y1_Amount;
      this.Coeffcient_Efficiency_Y2_Amount =
        data.Coeffcient_Efficiency_Y2_Amount;
      this.Coeffcient_Efficiency_Y3_Amount =
        data.Coeffcient_Efficiency_Y3_Amount;
      this.Coeffcient_Efficiency_Y4_Amount =
        data.Coeffcient_Efficiency_Y4_Amount;
      this.Coeffcient_Efficiency_Y5_Amount =
        data.Coeffcient_Efficiency_Y5_Amount;
      this.Coeffcient_Efficiency_Y6_Amount =
        data.Coeffcient_Efficiency_Y6_Amount;
      this.Coeffcient_Efficiency_Y7_Amount =
        data.Coeffcient_Efficiency_Y7_Amount;
      this.Coeffcient_Efficiency_Y8_Amount =
        data.Coeffcient_Efficiency_Y8_Amount;
      // if (data.Coeffcient_Efficiency_Y8_Amount == null) {
      //   this.Coeffcient_Efficiency_Y8_Amount = 'NaN'
      // }

      // 昌恩EMC项目年净收
      for (let i = 1; i <= 8; i++) {
        // 构建属性名  净收入
        const NetIncome = `HVACEMC_Commission_NetIncome_Y${i}`;
        this[NetIncome] = symbolOfRMB(data[NetIncome]);
        if (this[NetIncome] == undefined) {
          this[NetIncome] = 0;
        }
        // 年末余额
        const EndingBalance = `HVACEMC_Commission_EndingBalance_Y${i}`;
        this[EndingBalance] = symbolOfRMB(data[EndingBalance]);
        if (this[EndingBalance] == undefined) {
          this[EndingBalance] = 0;
        }
        console.log("昌恩EMC项目年净收", this[EndingBalance]);
      }

      // 项目回本时效
      this.HVACEMC_BEP = data.HVACEMC_BEP;
      this.HVACEMC_BSP = data.HVACEMC_BSP;

      // 项目提成比例   (修改规则，计算不出来的显示N/A)
      if (data.HVACEMC_CommissionRate_Sales == 0.0) {
        console.log(
          "项目提成比例:计算不出来显示N/A",
          data.HVACEMC_CommissionRate_Sales
        );
        // this.HVACEMC_CommissionRate_Sales = 'N / A'
        this.HVACEMC_CommissionRate_Sales = "0.0";
      } else {
        console.log("项目提成比例:可以计算", data.HVACEMC_CommissionRate_Sales);
        this.HVACEMC_CommissionRate_Sales =
          data.HVACEMC_CommissionRate_Sales.toFixed(2);
      }

      if (data.HVACEMC_CommissionRate_Supports == 0.0) {
        // this.HVACEMC_CommissionRate_Supports = 'N / A'
        this.HVACEMC_CommissionRate_Supports = "0.0";
      } else {
        this.HVACEMC_CommissionRate_Supports =
          data.HVACEMC_CommissionRate_Supports.toFixed(2);
      }

      if (data.HVACEMC_CommissionRate_Total == 0.0) {
        // this.HVACEMC_CommissionRate_Total = 'N / A'
        this.HVACEMC_CommissionRate_Total = "0.0";
      } else {
        this.HVACEMC_CommissionRate_Total =
          data.HVACEMC_CommissionRate_Total.toFixed(2);
      }

      // 项目提成比例 商务包
      // this.HVACEMC_CommissionRate_Agents = data.HVACEMC_CommissionRate_Agents
      if (data.HVACEMC_CommissionRate_Agents == 0.0) {
        this.HVACEMC_CommissionRate_Agents = "0.0";
      } else {
        this.HVACEMC_CommissionRate_Agents =
          data.HVACEMC_CommissionRate_Agents.toFixed(2);
      }

      // 项目预测提成金额 新字段处理
      for (let i = 1; i <= 8; i++) {
        // 商务包 Agents
        const agentsAmount = `HVACEMC_Commission_Agents_Y${i}_Amount`;
        this[agentsAmount] = symbolOfRMB(data[agentsAmount]);
        if (data[agentsAmount] == 0) {
          this[agentsAmount] = data[agentsAmount];
        }

        // 销售包Sales
        const SalesAmount = `HVACEMC_Commission_Sales_Y${i}_Amount`;
        this[SalesAmount] = symbolOfRMB(data[SalesAmount]);
        if (data[SalesAmount] == 0) {
          this[SalesAmount] = data[SalesAmount];
        }

        // 支持包Supports
        const SupportsAmount = `HVACEMC_Commission__Supports_Y${i}_Amount`;
        this[SupportsAmount] = symbolOfRMB(data[SupportsAmount]);
        if (data[SupportsAmount] == 0) {
          this[SupportsAmount] = data[SupportsAmount];
        }

        // 总金额 Total
        const TotalAmount = `HVACEMC_Commission__Total_Y${i}_Amount`;
        this[TotalAmount] = symbolOfRMB(data[TotalAmount]);
        if (data[TotalAmount] == 0) {
          this[TotalAmount] = data[TotalAmount];
        }
      }

      // 项目预测提成金额
      if (data.HVACEMC_Commission_Sales_Total == 0.0) {
        this.HVACEMC_Commission_Sales_Total = "N / A";
      } else {
        this.HVACEMC_Commission_Sales_Total = symbolOfRMB(
          data.HVACEMC_Commission_Sales_Total
        );
      }

      if (data.HVACEMC_Commission_Sales_AA == 0.0) {
        this.HVACEMC_Commission_Sales_AA = "N / A";
      } else {
        this.HVACEMC_Commission_Sales_AA = symbolOfRMB(
          data.HVACEMC_Commission_Sales_AA
        );
      }

      if (data.HVACEMC_Commission_Sales_MA == 0.0) {
        this.HVACEMC_Commission_Sales_MA = "N / A";
      } else {
        this.HVACEMC_Commission_Sales_MA = symbolOfRMB(
          data.HVACEMC_Commission_Sales_MA
        );
      }

      if (data.HVACEMC_Commission_Supports_Total == 0.0) {
        this.HVACEMC_Commission_Supports_Total = "N / A";
      } else {
        this.HVACEMC_Commission_Supports_Total = symbolOfRMB(
          data.HVACEMC_Commission_Supports_Total
        );
      }

      if (data.HVACEMC_Commission_Supports_AA == 0.0) {
        this.HVACEMC_Commission_Supports_AA = "N / A";
      } else {
        this.HVACEMC_Commission_Supports_AA = symbolOfRMB(
          data.HVACEMC_Commission_Supports_AA
        );
      }

      if (data.HVACEMC_Commission_Supports_MA == 0.0) {
        console.log("支持包金额", data.HVACEMC_Commission_Supports_MA);
        this.HVACEMC_Commission_Supports_MA = "N / A";
      } else {
        this.HVACEMC_Commission_Supports_MA = symbolOfRMB(
          data.HVACEMC_Commission_Supports_MA
        );
      }

      if (data.HVACEMC_Commission_Total_Total == 0.0) {
        this.HVACEMC_Commission_Total_Total = "N / A";
      } else {
        this.HVACEMC_Commission_Total_Total = symbolOfRMB(
          data.HVACEMC_Commission_Total_Total
        );
      }

      if (data.HVACEMC_Commission_Total_AA == 0.0) {
        this.HVACEMC_Commission_Total_AA = "N / A";
      } else {
        this.HVACEMC_Commission_Total_AA = symbolOfRMB(
          data.HVACEMC_Commission_Total_AA
        );
      }

      if (data.HVACEMC_Commission_Total_MA == 0.0) {
        this.HVACEMC_Commission_Total_MA = "N / A";
      } else {
        this.HVACEMC_Commission_Total_MA = symbolOfRMB(
          data.HVACEMC_Commission_Total_MA
        );
      }

      // 甲方EMC项目实际节能收益
      this.HVACEMC_Owner_Savings_Total = symbolOfRMB(
        data.HVACEMC_Owner_Savings_Total
      );
      // 昌恩EMC项目总营收
      this.HVACEMC_CE_Revenue_Total = symbolOfRMB(
        data.HVACEMC_CE_Revenue_Total
      );
      // 昌恩EMC项目提成前总毛利
      this.HVACEMC_CE_GrossProfitBC_Total = symbolOfRMB(
        data.HVACEMC_CE_GrossProfitBC_Total
      );

      // 昌恩EMC项目实际总毛利
      this.HVACEMC_CE_GrossProfit_Total = symbolOfRMB(
        data.HVACEMC_CE_GrossProfit_Total
      );
      this.HVACEMC_CE_GrossProfit_Margin = symbolOfRMB(
        data.HVACEMC_CE_GrossProfit_Margin
      );

      // 三、硬件买断模式项目回报测算
      // 昌恩项目售价
      this.HVACBO_CE_SellingPrice = symbolOfRMB(data.HVACBO_CE_SellingPrice); //总额
      this.HVACBO_CE_SellingPrice_Phase_1_P =
        data.HVACBO_CE_SellingPrice_Phase_1_P;
      this.HVACBO_CE_SellingPrice_Phase_2_P =
        data.HVACBO_CE_SellingPrice_Phase_2_P;

      this.HVACBO_CE_SellingPrice_Phase_3_P =
        data.HVACBO_CE_SellingPrice_Phase_3_P;

      this.HVACBO_CE_SellingPrice_Phase_1 = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_1
      );
      this.HVACBO_CE_SellingPrice_Phase_2 = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_2
      );
      this.HVACBO_CE_SellingPrice_Phase_3 = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_3
      );

      // 需求变更：总额可修改
      this.orginContent_HVACBO_CE_SellingPrice = symbolOfRMB(
        data.HVACBO_CE_SellingPrice
      );

      this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_1_P
      );
      console.log(
        "昌恩项目售价",
        this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P
      );

      this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_2_P
      );

      this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_3_P
      );

      // 昌恩运维收入
      this.HVACBO_CE_OMI_Annual = symbolOfRMB(data.HVACBO_CE_OMI_Annual);
      this.HVACBO_CE_OMI_Annual_Total = symbolOfRMB(
        data.HVACBO_CE_OMI_Annual_Total
      );

      this.orginContent_HVACBO_CE_OMI_Annual = symbolOfRMB(
        data.HVACBO_CE_OMI_Annual
      );

      // 昌恩项目销售提成
      this.HVACBO_Commission_P_Agents =
        data.HVACBO_Commission_P_Agents.toFixed(2);
      this.HVACBO_Commission_P_Sales =
        data.HVACBO_Commission_P_Sales.toFixed(2);
      this.HVACBO_Commission_P_Supports =
        data.HVACBO_Commission_P_Supports.toFixed(2);
      this.HVACBO_Commission_P_Total =
        data.HVACBO_Commission_P_Total.toFixed(2);

      this.orginContent_HVACBO_Commission_P_Agents =
        this.HVACBO_Commission_P_Agents;
      this.orginContent_HVACBO_Commission_P_Sales =
        this.HVACBO_Commission_P_Sales;
      this.orginContent_HVACBO_Commission_P_Supports =
        this.HVACBO_Commission_P_Supports;
      this.orginContent_HVACBO_Commission_P_Total =
        this.HVACBO_Commission_P_Total;

      this.HVACBO_Commission_Agents_Total = symbolOfRMB(
        data.HVACBO_Commission_Agents_Total
      );
      this.HVACBO_Commission_Sales_Total = symbolOfRMB(
        data.HVACBO_Commission_Sales_Total
      );
      this.HVACBO_Commission_Supports_Total = symbolOfRMB(
        data.HVACBO_Commission_Supports_Total
      );

      this.HVACBO_Commission_Total_Total = symbolOfRMB(
        data.HVACBO_Commission_Total_Total
      );

      // 昌恩合同总营收
      this.HVACBO_CE_Revenue_Total = symbolOfRMB(data.HVACBO_CE_Revenue_Total);
      // 昌恩项目提成前总毛利
      this.HVACBO_CE_GrossProfitBC_Total = symbolOfRMB(
        data.HVACBO_CE_GrossProfitBC_Total
      );
      // 昌恩项目实际总毛利
      this.HVACBO_CE_GrossProfit_Total = symbolOfRMB(
        data.HVACBO_CE_GrossProfit_Total
      );
      this.HVACBO_CE_GrossProfit_Margin = (
        data.HVACBO_CE_GrossProfit_Margin * 100
      ).toFixed(2);

      // 代理方项目售价
      this.HVACBO_Agent_SellingPrice = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice
      );
      this.HVACBO_Agent_SellingPrice_Phase_1_P =
        data.HVACBO_Agent_SellingPrice_Phase_1_P;

      this.HVACBO_Agent_SellingPrice_Phase_2_P =
        data.HVACBO_Agent_SellingPrice_Phase_2_P;
      this.HVACBO_Agent_SellingPrice_Phase_3_P =
        data.HVACBO_Agent_SellingPrice_Phase_3_P;

      this.HVACBO_Agent_SellingPrice_Phase_1 = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice_Phase_1
      );

      this.HVACBO_Agent_SellingPrice_Phase_2 = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice_Phase_2
      );

      this.HVACBO_Agent_SellingPrice_Phase_3 = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice_Phase_3
      );

      this.orginContent_HVACBO_Agent_SellingPrice =
        data.HVACBO_Agent_SellingPrice;
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P =
        data.HVACBO_Agent_SellingPrice_Phase_1_P;
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P =
        data.HVACBO_Agent_SellingPrice_Phase_2_P;
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P =
        data.HVACBO_Agent_SellingPrice_Phase_3_P;

      // 代理运维收入
      this.HVACBO_Agent_OMI_Annual = symbolOfRMB(data.HVACBO_Agent_OMI_Annual);
      this.HVACBO_Agent_OMI_Annual_Total = symbolOfRMB(
        data.HVACBO_Agent_OMI_Annual_Total
      );
      this.orginContent_HVACBO_Agent_OMI_Annual = symbolOfRMB(
        data.HVACBO_Agent_OMI_Annual
      );

      // 代理方项目总营收
      this.HVACBO_Agent_Revenue_Total = symbolOfRMB(
        data.HVACBO_Agent_Revenue_Total
      );
      // 代理方项目总毛利
      this.HVACBO_Agent_GrossProfit_Total = symbolOfRMB(
        data.HVACBO_Agent_GrossProfit_Total
      );

      this.HVACBO_Agent_GrossProfit_Margin = (
        data.HVACBO_Agent_GrossProfit_Margin * 100
      ).toFixed(2);

      // 甲方项目节能年均收益预测
      this.HVACBO_Owner_Savings_Annual_CE = symbolOfRMB(
        data.HVACBO_Owner_Savings_Annual_CE
      );
      this.HVACBO_Owner_CE_BEP = data.HVACBO_Owner_CE_BEP;

      this.HVACBO_Owner_Savings_Annual_Agent = symbolOfRMB(
        data.HVACBO_Owner_Savings_Annual_Agent
      );

      this.HVACBO_Owner_Agent_BEP = data.HVACBO_Owner_Agent_BEP;
      // 甲方项目节能6年实际毛收益 :昌恩直售实际收益
      this.HVACBO_Owner_Savings_Total = symbolOfRMB(
        data.HVACBO_Owner_Savings_Total
      );

      // 甲方项目节能6年实际毛收益： 代理销售实际收益
      this.HVACBO_Agent_Savings_Total = symbolOfRMB(
        data.HVACBO_Agent_Savings_Total
      );
    },

    // 新增接口
    async addProject(data) {
      this.loading = true;
      try {
        let res = await add(data);
        console.log("新增接口接受参数", data);
        console.log("新增接口响应结果", res);
        if (res.code == 0) {
          console.log("新增接口调用成功", res.data.success.id);
          let newDetail = await this.getDetail(res.data.success.id);
          this.loading = false;
          this.dumpData(newDetail.data.success);
        }
      } catch (error) {
        this.loading = false;
        // this.$message("请求出错了", error);
      }
    },
    goBack() {
      this.$router.push("home");
    },

    // 记录参数
    rememberInputData() {
      let paramsObj = {
        name: this.name,
        Create_User:
          this.$route.query.userName ||
          JSON.parse(localStorage.getItem("userInfo")).userName,
        HVAC_EnergyConsumption_Annual: removeSymbolOfRMB(
          this.HVAC_EnergyConsumption_Annual
        ), //项目暖通系统年用电量
        HVAC_AveragePSR_Annual: Number(this.HVAC_AveragePSR_Annual), // 年均节能率
        Power_UnitPrice: removeSymbolOfRMB(this.Power_UnitPrice), //电费单价
        Cost_Construction: removeSymbolOfRMB(this.Cost_Construction), //建设毛成本
        Cost_OM_Anuual: removeSymbolOfRMB(this.Cost_OM_Anuual), // 项目运维成本
        Loan_Amount: removeSymbolOfRMB(this.Loan_Amount), //项目贷款额
        Loan_InterestRate_Annual: this.Loan_InterestRate_Annual, //贷款年利率  (number)
        Loan_Term: removeSymbolOfRMB(this.Loan_Term), //贷款年限

        // 项目贷款情况*
        Loan_Status: this.Loan_Status,
        // 项目分成模式选择
        HVACEMC_BSM_CEBSP: this.HVACEMC_BSM_CEBSP, // 项目分成模式选择：固定比例/浮动比例
        HVACEMC_BSM_CEBSP_FP: removeSymbolOfRMB(this.HVACEMC_BSM_CEBSP_FP),
        HVACEMC_BSM_CEBSP_P1: removeSymbolOfRMB(this.HVACEMC_BSM_CEBSP_P1),
        HVACEMC_BSM_CEBSP_P2: removeSymbolOfRMB(this.HVACEMC_BSM_CEBSP_P2),

        // 硬件买断模式项目回报测算:
        // 昌恩项目售价
        HVACBO_CE_SellingPrice_Phase_1_P: removeSymbolOfRMB(
          this.HVACBO_CE_SellingPrice_Phase_1_P
        ),
        HVACBO_CE_SellingPrice_Phase_2_P: removeSymbolOfRMB(
          this.HVACBO_CE_SellingPrice_Phase_2_P
        ),
        // HVACBO_CE_SellingPrice_Phase_3_P: removeSymbolOfRMB(
        //   this.HVACBO_CE_SellingPrice_Phase_3_P
        // ),
        // 代理方项目售价
        HVACBO_Agent_SellingPrice_Phase_1_P: removeSymbolOfRMB(
          this.HVACBO_Agent_SellingPrice_Phase_1_P
        ),
        HVACBO_Agent_SellingPrice_Phase_2_P: removeSymbolOfRMB(
          this.HVACBO_Agent_SellingPrice_Phase_2_P
        ),
        // HVACBO_Agent_SellingPrice_Phase_3_P: removeSymbolOfRMB(
        //   this.HVACBO_Agent_SellingPrice_Phase_3_P
        // ),

        // 昌恩项目分成模式 百分比
        HVACEMC_BSM_CE_Y1_Rate: Number(this.HVACEMC_BSM_CE_Y1_Rate),
        HVACEMC_BSM_CE_Y2_Rate: Number(this.HVACEMC_BSM_CE_Y2_Rate),
        HVACEMC_BSM_CE_Y3_Rate: Number(this.HVACEMC_BSM_CE_Y3_Rate),
        HVACEMC_BSM_CE_Y4_Rate: Number(this.HVACEMC_BSM_CE_Y4_Rate),
        HVACEMC_BSM_CE_Y5_Rate: Number(this.HVACEMC_BSM_CE_Y5_Rate),
        HVACEMC_BSM_CE_Y6_Rate: Number(this.HVACEMC_BSM_CE_Y6_Rate),
        HVACEMC_BSM_CE_Y7_Rate: Number(this.HVACEMC_BSM_CE_Y7_Rate),
        HVACEMC_BSM_CE_Y8_Rate: Number(this.HVACEMC_BSM_CE_Y8_Rate),

        // // 项目提成比例
        HVACEMC_CommissionRate_Agents: Number(
          this.HVACEMC_CommissionRate_Agents
        ),
        HVACEMC_CommissionRate_Sales: Number(this.HVACEMC_CommissionRate_Sales),
        HVACEMC_CommissionRate_Supports: Number(
          this.HVACEMC_CommissionRate_Supports
        ),
        HVACEMC_CommissionRate_Total: Number(this.HVACEMC_CommissionRate_Total),

        // 昌恩项目售价 总额
        HVACBO_CE_SellingPrice: removeSymbolOfRMB(this.HVACBO_CE_SellingPrice),

        // 昌恩运维收入
        HVACBO_CE_OMI_Annual: removeSymbolOfRMB(this.HVACBO_CE_OMI_Annual),

        // 代理方项目售价 总额
        HVACBO_Agent_SellingPrice: Number(
          removeSymbolOfRMB(this.HVACBO_Agent_SellingPrice)
        ),

        // 昌恩项目分成模式 年限
        HVACEMC_ContractTerm_Year: this.HVACEMC_ContractTerm_Year,

        // 代理运维收入
        HVACBO_Agent_OMI_Annual: removeSymbolOfRMB(
          this.HVACBO_Agent_OMI_Annual
        ),

        // 昌恩项目销售提成
        HVACBO_Commission_P_Agents: this.HVACBO_Commission_P_Agents,
        HVACBO_Commission_P_Sales: this.HVACBO_Commission_P_Sales,
        HVACBO_Commission_P_Supports: this.HVACBO_Commission_P_Supports,
        HVACBO_Commission_P_Total: this.HVACBO_Commission_P_Total,
      };
      console.log("当前所有输入参数", paramsObj);
      return paramsObj;
    },

    //1
    baseItemAnnualElectricityConsumption(event) {
      this.showBtn1 = false;
      this.$nextTick(() => {
        this.$refs.btnAnnualElectricityConsumption.focus();
      });
    },
    cancel() {
      this.showBtn1 = true;
      this.HVAC_EnergyConsumption_Annual = symbolOfRMB(
        this.orginContent_HVAC_EnergyConsumption_Annual
      );
    },
    confirm(event) {
      this.showBtn1 = true;
      this.orginContent_HVAC_EnergyConsumption_Annual =
        this.HVAC_EnergyConsumption_Annual;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    //2 年均节能率
    baseHVAC_AveragePSR_Annual() {
      this.showBtn2 = false;
      this.$nextTick(() => {
        this.$refs.btnHVAC_AveragePSR_Annual.focus();
      });
    },
    cancel2() {
      this.showBtn2 = true;
      this.HVAC_AveragePSR_Annual = this.orginContent_HVAC_AveragePSR_Annual;
    },
    confirm2(event) {
      this.showBtn2 = true;
      this.orginContent_HVAC_AveragePSR_Annual = this.HVAC_AveragePSR_Annual;

      console.log("提交了数据：", this.HVAC_AveragePSR_Annual);
      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
    // 3 .电费单价
    basePower_UnitPrice() {
      this.showBtn3 = false;
      this.$nextTick(() => {
        this.$refs.btnPower_UnitPrice.focus();
      });
    },
    cancel3() {
      this.showBtn3 = true;
      this.Power_UnitPrice = this.orginContent_Power_UnitPrice;
    },
    confirm3(event) {
      this.showBtn3 = true;
      this.orginContent_Power_UnitPrice = this.Power_UnitPrice;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    // 4.建设毛成本
    baseCost_Construction() {
      this.showBtn4 = false;
      this.$nextTick(() => {
        this.$refs.btnCost_Construction.focus();
      });
    },
    cancel4() {
      this.showBtn4 = true;
      this.Cost_Construction = symbolOfRMB(this.orginContent_Cost_Construction);
    },
    confirm4(event) {
      this.showBtn4 = true;
      this.orginContent_Cost_Construction = this.Cost_Construction;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
    // 5.项目运维成本
    baseCost_OM_Anuual() {
      this.showBtn5 = false;
      this.$nextTick(() => {
        this.$refs.btnCost_OM_Anuual.focus();
      });
    },
    cancel5() {
      this.showBtn5 = true;
      this.Cost_OM_Anuual = symbolOfRMB(this.orginContent_Cost_OM_Anuual);
    },
    confirm5(event) {
      this.showBtn5 = true;
      this.orginContent_Cost_OM_Anuual = this.Cost_OM_Anuual;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
    // 6.项目贷款情况
    baseLoan_Status() {
      this.showBtn6 = false;
    },
    cancel6() {
      this.showBtn6 = true;
      this.Loan_Status = this.orginContent_Loan_Status;
    },
    confirm6(event) {
      this.showBtn6 = true;
      this.orginContent_Loan_Status = this.Loan_Status;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    // 5.项目贷款额
    baseLoan_Amount() {
      this.showBtn7 = false;
      this.$nextTick(() => {
        this.$refs.btnLoan_Amount.focus();
      });
    },
    cancel7() {
      this.showBtn7 = true;
      this.Loan_Amount = symbolOfRMB(this.orginContent_Loan_Amount);
    },
    confirm7(event) {
      this.showBtn7 = true;
      this.orginContent_Loan_Amount = this.Loan_Amount;
      console.log(
        "判断项目贷款额数据类型（要传string）",
        typeof this.Loan_Amount
      );

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    // 合并 贷款年利率 + 贷款年限
    baseLoan_InterestRate_Annual() {
      this.showBtn8 = false;
      this.$nextTick(() => {
        this.$refs.btnLoan_InterestRate_Annual.focus();
      });
    },
    cancel8() {
      this.showBtn8 = true;
      this.Loan_InterestRate_Annual =
        this.orginContent_Loan_InterestRate_Annual;
      // 年限
      this.Loan_Term = this.orginContent_Loan_Term;
    },
    confirm8(event) {
      this.showBtn8 = true;
      this.orginContent_Loan_InterestRate_Annual =
        this.Loan_InterestRate_Annual;
      // 年限
      this.orginContent_Loan_Term = this.Loan_Term;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
    // 单选框判断置灰
    select_Loan_Status(val) {
      console.log("val", val);
      if (val == 1) {
        this.showGrey = true;
        this.Loan_Status = 1;
      } else {
        this.Loan_Status = 0;
        this.showGrey = false;
      }
      this.addProject(this.rememberInputData());
    },

    // 项目分成模式选择
    // select_HVACEMC_BSM_CEBSP (val) {
    //   console.log('val', val)
    //   this.HVACEMC_BSM_CEBSP = val
    //   if (val == 1) {
    //     console.log('项目分成模式选择1 :浮动')
    //     // 数据处理，调接口传参
    //     this.addProject(this.rememberInputData())
    //   } else {
    //     // 数据处理，调接口传参
    //     this.addProject(this.rememberInputData())
    //     console.log('项目分成模式选择0 :固定')
    //   }
    // },

    // 二、能源管理合同模式 (EMC) 项目回报测算
    modeHVACEMC_BSM_CEBSP_FP() {
      this.showBtn_HVACEMC_BSM_CEBSP = false;
      this.$nextTick(() => {
        this.$refs.btnHVACEMC_BSM_CEBSP1.focus();
        // if (this.HVACEMC_BSM_CEBSP == 0) {
        //   this.$refs.btnHVACEMC_BSM_CEBSP.focus()
        // } else {
        //   this.$refs.btnHVACEMC_BSM_CEBSP_P1.focus()
        // }
      });
    },

    cancel_HVACEMC_BSM_CEBSP_FP() {
      console.log("取消");
      this.showBtn_HVACEMC_BSM_CEBSP = true;
      // this.HVACEMC_BSM_CEBSP_FP = this.orginContent_HVACEMC_BSM_CEBSP_FP
      // this.HVACEMC_BSM_CEBSP_P1 = this.orginContent_HVACEMC_BSM_CEBSP_P1
      // this.HVACEMC_BSM_CEBSP_P2 = this.orginContent_HVACEMC_BSM_CEBSP_P2
      this.HVACEMC_BSM_CE_Y1_Rate = this.orginContent_HVACEMC_BSM_CE_Y1_Rate;
      this.HVACEMC_BSM_CE_Y2_Rate = this.orginContent_HVACEMC_BSM_CE_Y2_Rate;
      this.HVACEMC_BSM_CE_Y3_Rate = this.orginContent_HVACEMC_BSM_CE_Y3_Rate;
      this.HVACEMC_BSM_CE_Y4_Rate = this.orginContent_HVACEMC_BSM_CE_Y4_Rate;
      this.HVACEMC_BSM_CE_Y5_Rate = this.orginContent_HVACEMC_BSM_CE_Y5_Rate;
      this.HVACEMC_BSM_CE_Y6_Rate = this.orginContent_HVACEMC_BSM_CE_Y6_Rate;
      this.HVACEMC_BSM_CE_Y7_Rate = this.orginContent_HVACEMC_BSM_CE_Y7_Rate;
      this.HVACEMC_BSM_CE_Y8_Rate = this.orginContent_HVACEMC_BSM_CE_Y8_Rate;
    },
    confirm_HVACEMC_BSM_CEBSP_FP(event) {
      console.log("确认");
      this.showBtn_HVACEMC_BSM_CEBSP = true;
      // this.orginContent_HVACEMC_BSM_CEBSP_FP = this.HVACEMC_BSM_CEBSP_FP
      // this.orginContent_HVACEMC_BSM_CEBSP_P1 = this.HVACEMC_BSM_CEBSP_P1
      // this.orginContent_HVACEMC_BSM_CEBSP_P2 = this.HVACEMC_BSM_CEBSP_P2
      this.orginContent_HVACEMC_BSM_CE_Y1_Rate = this.HVACEMC_BSM_CE_Y1_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y2_Rate = this.HVACEMC_BSM_CE_Y2_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y3_Rate = this.HVACEMC_BSM_CE_Y3_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y4_Rate = this.HVACEMC_BSM_CE_Y4_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y5_Rate = this.HVACEMC_BSM_CE_Y5_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y6_Rate = this.HVACEMC_BSM_CE_Y6_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y7_Rate = this.HVACEMC_BSM_CE_Y7_Rate;
      this.orginContent_HVACEMC_BSM_CE_Y8_Rate = this.HVACEMC_BSM_CE_Y8_Rate;

      this.HVACEMC_BSM_CEBSP = 1;
      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    // --
    baseItemHVACEMC_CommissionRate() {
      this.showBtn_CommissionRate = false;
      this.$nextTick(() => {
        this.$refs.btnHVACEMC_CommissionRate_Agents.focus();
      });
    },

    cancel_HVACEMC_CommissionRate() {
      console.log("取消");
      this.showBtn_CommissionRate = true;

      this.HVACEMC_CommissionRate_Agents =
        this.originContent_HVACEMC_CommissionRate_Agents;
      this.HVACEMC_CommissionRate_Sales =
        this.originContent_HVACEMC_CommissionRate_Sales;
      this.HVACEMC_CommissionRate_Supports =
        this.originContent_HVACEMC_CommissionRate_Supports;
      this.HVACEMC_CommissionRate_Total =
        this.originContent_HVACEMC_CommissionRate_Total;
    },
    confirm_HVACEMC_CommissionRate(event) {
      console.log("确认");
      this.showBtn_CommissionRate = true;

      this.originContent_HVACEMC_CommissionRate_Agents =
        this.HVACEMC_CommissionRate_Agents;
      this.originContent_HVACEMC_CommissionRate_Sales =
        this.HVACEMC_CommissionRate_Sales;
      this.originContent_HVACEMC_CommissionRate_Supports =
        this.HVACEMC_CommissionRate_Supports;
      this.originContent_HVACEMC_CommissionRate_Total =
        this.HVACEMC_CommissionRate_Total;

      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
    //

    // 三、
    // 昌恩项目售价
    baseItemHVACBO_CE_SellingPrice() {
      this.showBtn_Annual = false;
      this.$nextTick(() => {
        this.$refs.btnHVACBO_CE_SellingPrice_Phase_1_P.focus();
      });
    },
    cancel_HVACBO_CE_SellingPrice_Phase_1_P() {
      this.showBtn_Annual = true;
      // this.HVAC_EnergyConsumption_Annual = this.orginContent
      this.HVACBO_CE_SellingPrice_Phase_1_P =
        this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P;
      this.HVACBO_CE_SellingPrice_Phase_2_P =
        this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P;
      this.HVACBO_CE_SellingPrice_Phase_3_P =
        this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P;

      // 需求变更：昌恩项目售价- 总额可修改
      this.HVACBO_CE_SellingPrice = this.orginContent_HVACBO_CE_SellingPrice;

      // 需求变更：代理方项目售价 - 总额可修改
    },
    confirm_HVACBO_CE_SellingPrice_Phase_1_P(event) {
      // 判断首款和2款为必填
      console.log(
        "判断首款为必填",
        this.filterLoan_HVACBO_CE_SellingPrice_Phase_1_P
      );
      console.log(
        "判断2款为必填",
        this.filterLoan_HVACBO_CE_SellingPrice_Phase_2_P
      );

      if (
        this.filterLoan_HVACBO_CE_SellingPrice_Phase_1_P == 0 ||
        this.filterLoan_HVACBO_CE_SellingPrice_Phase_2_P == 0
      ) {
        console.log("存在必传未填");
      } else {
        console.log("所有必传已填");
        this.showBtn_Annual = true;

        this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P =
          this.HVACBO_CE_SellingPrice_Phase_1_P;
        this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P =
          this.HVACBO_CE_SellingPrice_Phase_2_P;
        this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P =
          this.HVACBO_CE_SellingPrice_Phase_3_P;

        // 需求变更：总额可修改
        this.orginContent_HVACBO_CE_SellingPrice = this.HVACBO_CE_SellingPrice;

        // 数据处理，调接口传参
        this.addProject(this.rememberInputData());
      }
    },
    // 昌恩运维收入
    baseItemHVACBO_CE_OMI_Annual() {
      this.showBtn_OMI = false;
      this.$nextTick(() => {
        this.$refs.btnHVACBO_CE_OMI_Annual_Total.focus();
      });
    },
    cancel_HVACBO_CE_OMI_Annual() {
      this.showBtn_OMI = true;
      this.HVACBO_CE_OMI_Annual = this.orginContent_HVACBO_CE_OMI_Annual;
    },
    confirm_HVACBO_CE_OMI_Annual() {
      this.showBtn_OMI = true;
      this.orginContent_HVACBO_CE_OMI_Annual = this.HVACBO_CE_OMI_Annual;
      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    // 昌恩项目销售提成
    baseItemHVACBO_Commission_Agents() {
      this.showBtn_HVACBO = false;
      this.$nextTick(() => {
        this.$refs.HVACBO_Commission_P_Agents.focus();
      });
    },

    cancel_HVACBO_Commission_Agents() {
      this.showBtn_HVACBO = true;
      this.HVACBO_Commission_P_Agents =
        this.orginContent_HVACBO_Commission_P_Agents;
      this.HVACBO_Commission_P_Sales =
        this.orginContent_HVACBO_Commission_P_Sales;
      this.HVACBO_Commission_P_Supports =
        this.orginContent_HVACBO_Commission_P_Supports;
      this.HVACBO_Commission_P_Total =
        this.orginContent_HVACBO_Commission_P_Total;

      console.log("xxxxxxxxx1", this.HVACBO_Commission_P_Agents);
      console.log("xxxxxxxxx2", this.HVACBO_Commission_P_Sales);
      console.log("xxxxxxxxx3", this.HVACBO_Commission_P_Supports);
      console.log("xxxxxxxxx4", this.HVACBO_Commission_P_Total);
    },
    confirm_HVACBO_Commission_Agents() {
      this.showBtn_HVACBO = true;

      this.orginContent_HVACBO_Commission_P_Agents =
        this.HVACBO_Commission_P_Agents;
      this.orginContent_HVACBO_Commission_P_Sales =
        this.HVACBO_Commission_P_Sales;
      this.orginContent_HVACBO_Commission_P_Supports =
        this.HVACBO_Commission_P_Supports;
      this.orginContent_HVACBO_Commission_P_Total =
        this.HVACBO_Commission_P_Total;

      this.addProject(this.rememberInputData());
    },

    // 代理方项目售价--
    hardwareHVACBO_Agent_SellingPrice_Phase_1_P() {
      this.showBtn_Agent = false;
      this.$nextTick(() => {
        this.$refs.btnHVACBO_Agent_SellingPrice_Phase_1_P.focus();
      });
    },
    cancel_Agent() {
      this.showBtn_Agent = true;

      // 总额可修改
      this.HVACBO_Agent_SellingPrice =
        this.orginContent_HVACBO_Agent_SellingPrice;

      this.HVACBO_Agent_SellingPrice_Phase_1_P =
        this.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P;
      this.HVACBO_Agent_SellingPrice_Phase_2_P =
        this.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P;
      this.HVACBO_Agent_SellingPrice_Phase_3_P =
        this.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P;
    },
    confirm_Agent(event) {
      this.showBtn_Agent = true;
      // this.orginContent = this.HVAC_EnergyConsumption_Annual
      // 总额可修改

      this.orginContent_HVACBO_Agent_SellingPrice =
        this.HVACBO_Agent_SellingPrice;

      this.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P =
        this.HVACBO_Agent_SellingPrice_Phase_1_P;
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P =
        this.HVACBO_Agent_SellingPrice_Phase_2_P;
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P =
        this.HVACBO_Agent_SellingPrice_Phase_3_P;

      console.log(
        "this.orginContent_HVACBO_Agent_SellingPrice",
        this.orginContent_HVACBO_Agent_SellingPrice
      );
      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
    // 单独表单校验
    validateInput() {
      // 根据自定义的校验规则进行校验
      console.log(
        "触发表单检验",
        this.filterLoan_HVACBO_CE_SellingPrice_Phase_1_P
      );
      if (this.filterLoan_HVACBO_CE_SellingPrice_Phase_1_P == "") {
        this.isInputInvalid = true;
        // this.placeholder = '内容不能为空'
        console.log("触发表单检验--失败");
      } else {
        this.isInputInvalid = false;
        // this.placeholder = ''
        console.log("触发表单检验--通过");

        this.showBtn_Annual = true;

        this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P =
          this.HVACBO_CE_SellingPrice_Phase_1_P;
        this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P =
          this.HVACBO_CE_SellingPrice_Phase_2_P;
        this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P =
          this.HVACBO_CE_SellingPrice_Phase_3_P;
        // 数据处理，调接口传参
        this.addProject(this.rememberInputData());
      }
      console.log("6");
    },

    // 选择年限
    changePeriod(value) {
      const lastCharacter = value.slice(-1);
      console.log(lastCharacter); // "6"
      this.showPeriod = lastCharacter;
      switch (value) {
        case "5":
          console.log("选择5");
          this.HVACEMC_ContractTerm_Year = 5;
          break;
        case "6":
          console.log("选择6");
          this.HVACEMC_ContractTerm_Year = 6;
          break;
        case "7":
          console.log("选择7");
          this.HVACEMC_ContractTerm_Year = 7;
          break;
        case "8":
          console.log("选择8");
          this.HVACEMC_ContractTerm_Year = 8;
          break;

        default:
          break;
      }
      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },

    //  代理运维收入
    baseItemHVACBO_Agent_OMI_Annual() {
      this.showBtn_AgentOMI = false;
      this.$nextTick(() => {
        this.$refs.btnHVACBO_Agent_OMI_Annual.focus();
      });
    },
    cancel_HVACBO_Agent_OMI_Annual() {
      this.showBtn_AgentOMI = true;
      this.HVACBO_Agent_OMI_Annual = this.orginContent_HVACBO_Agent_OMI_Annual;
    },
    confirm_HVACBO_Agent_OMI_Annual() {
      this.showBtn_AgentOMI = true;
      this.orginContent_HVACBO_Agent_OMI_Annual = this.HVACBO_Agent_OMI_Annual;
      // 数据处理，调接口传参
      this.addProject(this.rememberInputData());
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  overflow: hidden;
  padding: 10px 16px;
  // background-color: #072d96;
  background-color: #74737622;
  // background-color: #002060;
  // color: #fff;
}
::v-deep .el-input__inner {
  border: none;
  background-color: transparent !important;
}
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #000;
}
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    margin: 20px 20px 20px 0;
    padding-bottom: 10px;
    text-align: left;
    color: rgba(@homeBoxColor, 0.9);
    font-size: 30px;
    font-weight: 600;
  }
  .backContainer {
    position: absolute;
    right: 30px;
    // margin-right: 50px;
    cursor: pointer;
    .backImg {
      width: 24px;
      height: 24px;
    }
    .backTxt {
      padding-left: 10px;
      font-size: 14px;
    }
  }
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

h3 {
  padding: 20px 0 30px 0;
  // color: #072d96;
}

.clearfix p {
  font-size: 14px;
}
.el-card {
  height: 140px;
  border-radius: 10px;
}
::v-deep .el-card__header {
  height: 60px;
}

::v-deep .el-input-group__append {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: left;
}
.projectName ::v-deep .el-form-item__label {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
}
.projectName .el-input {
  border: 1px solid #303133;
  border-radius: 6px;
  width: 300px;
}
.projectName ::v-deep .el-form-item__label .el-input__inner {
  color: #303133;
}
.itemContent {
  // width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.year {
  // width: 70px;
  min-width: 50px;
  font-size: 14px;
  // background-color: orange;
}

.formatInput {
  width: 80px;
  border: none;
  outline: none;
  // background-color: red;
}
.el-radio {
  padding: 6px 0;
}
.endItem {
  margin-bottom: 10px;
}

// 置灰
.greyOut {
  background-color: #c0c0c0;
}
.greyOut ::v-deep .el-input__inner {
  background-color: transparent !important;
}
.greyOut .clearfix i {
  color: #858181;
}
.greyOut .clearfix p {
  color: #858181;
}
.greyOut .clearfix .el-button {
  background-color: #c0c0c0 !important;
  border: none;
}
.greyOut ::v-deep .el-input-group__append {
  background-color: transparent;
}

.el-button {
  border: none !important;
  background-color: transparent;
  color: #303133;
}

.setLeft ::v-deep .el-input__inner {
  text-align: left;
  padding: 0;
}
.setCenter ::v-deep .el-input__inner {
  text-align: center;
  padding: 0;
}
.setRight ::v-deep .el-input__inner {
  text-align: right;
  padding: 0;
}
.pd0 ::v-deep .el-input__inner {
  padding: 0;
  // text-align: right;
}
// 详情页进入按钮不可点击
/* ::v-deep .el-button--primary.is-disabled {
  background-color: #fff !important;
  color: #303133 !important;
} */

.custom_card ::v-deep .el-card__body {
  padding: 10px;
}
.setMargin {
  margin-top: -10px;
}

// 第二个容器
.itemContainer2 {
  margin: 60px 0;
  .row-box {
    display: flex;
    flex-flow: wrap;
  }
  .row-box .el-card {
    // height: 350px;
    height: auto;
    border-radius: 8px;
    margin: 6px 0;
  }
  .card_height.el-card {
    height: calc(100% - 13px);
  }

  .commission-rate-card ::v-deep .el-card__body {
    height: 100%;
    // background-color: red;
  }
  .commission-rate-card ::v-deep .el-input__inner {
    padding-left: 0 !important;
  }
  // .commission-rate {
  //   height: calc(100% - 60px);
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   justify-content: space-between;
  // }

  .commission-rate .hvacemc_bsm_cebsp {
    margin-bottom: -10px;
  }
  .row-box .box-card2.el-card {
    // height: 140px;
    height: calc(100% - 12px);
  }
  .row-box .el-card:hover {
    box-shadow: 0 2px 12px 0 rgb(255 25 255 / 10%);
  }

  .row-box .EMCBox {
    height: 180px;
  }

  .hvacemc_bsm_cebsp ::v-deep .el-input__inner {
    text-align: right;
    min-width: 60px;
    padding: 0 10px;
  }

  ::v-deep .el-form-item__label {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 32px;
    text-align: left;
  }

  .noBorder ::v-deep .el-input__inner {
    border: none !important;
    font-weight: 700;
  }
  .projectOperation {
    text-align: left;
  }
  .el-radio-group {
    text-align: left;
  }
  .el-radio-group .el-radio {
    padding: 8px 0;
  }

  .redcolor ::v-deep .el-input__inner {
    color: red !important;
  }
  .grayColor ::v-deep .el-input__inner {
    color: gray !important;
  }

  .greenColor ::v-deep .el-input__inner {
    color: green !important;
  }
  .redcolor {
    color: red !important;
  }
  .grayColor {
    color: gray !important;
  }

  .greenColor {
    color: green !important;
  }
  .restFormItemMargin.el-form-item {
    margin-bottom: 0;
  }
  // 设置input无背景色
  .noBgc ::v-deep .el-input__inner {
    background-color: transparent !important;
    color: #303133 !important;
  }

  .clearfix p {
    font-size: 14px;
  }
  .setFont24 {
    padding-top: 10px;
    font-size: 24px;
  }
  .el-card {
    height: 140px;
    border-radius: 10px;
  }
  ::v-deep .el-card__header {
    height: 60px;
  }
  ::v-deep .el-input-group__append {
    background-color: #fff;
    border: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }
  .itemContent {
    // width: 80px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .year {
    width: 80px;
    font-size: 14px;
  }

  .formatInput {
    width: 80px;
    border: none;
    outline: none;
  }
  .el-radio {
    padding: 6px 0;
  }
  .endItem {
    margin-bottom: 10px;
  }
  .endItemP {
    margin-top: -10px;
    margin-left: 16px;
  }

  // .el-button {
  //   border: none !important;
  //   background-color: transparent;
  //   color: #303133;
  // }
  .sixtyPoints {
    font-size: 12px;
  }
  p {
    font-size: 14px;
  }
  .divisibleYear {
    margin-top: 50px;
  }
  .set_T-A-C ::v-deep .el-input__inner {
    text-align: center;
  }
  .salesPackage {
    // margin-top: 24px;
  }

  .pd0 ::v-deep .el-input__inner {
    padding: 0;
  }
  .setLeft ::v-deep .el-input__inner {
    text-align: left;
    padding: 0;
  }
  .setCenter ::v-deep .el-input__inner {
    text-align: center;
    padding: 0;
  }
  .setRight ::v-deep .el-input__inner {
    text-align: right;
    padding: 0;
  }
  ::v-deep .el-input-group__prepend {
    background-color: transparent;
    border: none;
    padding: 0;
  }

  // 效益系数
  .xyxs ::v-deep .el-input__inner {
    text-align: right;
    min-width: 60px;
    padding: 0 10px;
  }
}
.itemContainer3 {
  margin-bottom: 50px;
  .projectSharingModeSelection {
    margin: 0;
  }

  h3 {
    padding: 20px 0 30px 0;
  }
  .row-box {
    display: flex;
    flex-flow: wrap;
  }
  .row-box .el-card {
    height: 260px;
    border-radius: 8px;
  }

  .row-box .el-card:hover {
    box-shadow: 0 2px 12px 0 rgb(255 25 255 / 10%);
  }

  .row-box .box-card {
    // height: 294px;
    height: 260px;
  }
  ::v-deep .el-form-item__label {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 32px;
    text-align: left;
  }

  .noBorder ::v-deep .el-input__inner {
    border: none !important;
    font-weight: 700;
  }
  .projectOperation {
    text-align: left;
  }
  .el-radio-group {
    text-align: left;
  }
  .el-radio-group .el-radio {
    padding: 8px 0;
  }

  .projectSharingModeSelection ::v-deep .el-input__inner {
    margin: 8px 0 !important;
  }

  .redcolor ::v-deep .el-input__inner {
    color: red !important;
  }
  .grayColor ::v-deep .el-input__inner {
    color: gray !important;
  }

  .greenColor ::v-deep .el-input__inner {
    color: green !important;
  }
  .redcolor {
    color: red !important;
  }
  .grayColor {
    color: gray !important;
  }

  .greenColor {
    color: green !important;
  }
  .restFormItemMargin.el-form-item {
    margin-bottom: 0;
  }
  .salesCommissions {
    display: flex;
    align-items: start;
  }
  .salesCommissions .percentage {
    margin-top: 13px;
  }
  // 设置input无背景色
  .noBgc ::v-deep .el-input__inner {
    background-color: transparent !important;
    color: #303133 !important;
  }

  .totalPrice::v-deep .el-input__inner {
    text-align: center;
  }
  // 输入框文字右对齐
  .hvacemc_bsm_cebsp ::v-deep .el-input__inner {
    text-align: right;
    min-width: 60px;
    padding: 0 10px;
  }
  p {
    font-size: 14px;
  }
  // .el-button {
  //   border: none !important;
  //   background-color: transparent;
  //   color: #303133;
  // }

  .setTxtLeft ::v-deep .el-input__inner {
    text-align: left;
  }
  .pd0 ::v-deep .el-input__inner {
    padding: 0;
  }

  .totalContractRevenue {
    margin-top: -18px;
  }
  .totalContractRevenue ::v-deep .el-input__inner {
    // margin-top: -8px;
    margin: 0;
    padding: 0;
  }

  .setLeft ::v-deep .el-input__inner {
    text-align: left;
    padding: 0;
  }
  .setCenter ::v-deep .el-input__inner {
    text-align: center;
    padding: 0;
  }
  .setRight ::v-deep .el-input__inner {
    text-align: right;
    padding: 0;
  }
  ::v-deep .el-input-group__prepend {
    background-color: transparent;
    border: none;
    padding: 0;
  }
  // 详情页进入按钮不可点击
  // ::v-deep .el-button--primary.is-disabled {
  //   background-color: #fff !important;
  //   color: #303133 !important;
  // }
}
// 编辑按钮鼠标悬停样式
::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background: #66b1ff !important;
  color: #fff !important;
}

::v-deep .el-button--info:focus,
.el-button--info:hover {
  background: #a6a9ad !important;
  color: #fff !important;
}

::v-deep .el-button--success:focus,
.el-button--success:hover {
  background: #85ce61 !important;
  color: #fff !important;
}
</style>
